/**
 * @file Generated by js-routes 2.4.1. Based on Rails 8.1.3.1 routes of Cropio::Application.
 * @version 8ff2453636b8fe850d7b104d2393478b177fb7cd344decdb195c6d722c6868a6
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: false,
        include_undefined_query_parameters: false,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * /shared_weather_stations/:id/actual_info(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const actual_info_shared_weather_station_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shared_weather_stations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"actual_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/agri_work_plans/add_agro_operations_to_agri_work_plan(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_agro_operations_to_agri_work_plan_json_agri_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"add_agro_operations_to_agri_work_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /new_awp_design/agri_work_plans/:id/add_agro_operations_to_plan(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_agro_operations_to_plan_new_awp_design_agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_awp_design"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_agro_operations_to_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /manual_work_plans/:id/add_manual_work_plan_items_to_plan(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_manual_work_plan_items_to_plan_manual_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manual_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_manual_work_plan_items_to_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agri_work_plans/:agri_work_plan_id/machine_work_plans/add_rows(.:format)
 * @param {any} agri_work_plan_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_rows_agri_work_plan_machine_work_plans_path = /*#__PURE__*/ __route({"agri_work_plan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"agri_work_plan_id"],[2,[7,"/"],[2,[6,"machine_work_plans"],[2,[7,"/"],[2,[6,"add_rows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /additional_objects/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const additional_object_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"additional_objects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agri_work_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agri_work_dashboard_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agri_work_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /agri_work_dashboard/work_data_for_group(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agri_work_dashboard_work_data_for_group_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agri_work_dashboard"],[2,[7,"/"],[2,[6,"work_data_for_group"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agri_work_dashboard/work_data_for_type(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agri_work_dashboard_work_data_for_type_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agri_work_dashboard"],[2,[7,"/"],[2,[6,"work_data_for_type"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agri_work_plans/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agri_work_plans/:agri_work_plan_id/machine_work_plans/:id(.:format)
 * @param {any} agri_work_plan_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agri_work_plan_machine_work_plan_path = /*#__PURE__*/ __route({"agri_work_plan_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"agri_work_plan_id"],[2,[7,"/"],[2,[6,"machine_work_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agri_work_plans/:agri_work_plan_id/machine_work_plans(.:format)
 * @param {any} agri_work_plan_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agri_work_plan_machine_work_plans_path = /*#__PURE__*/ __route({"agri_work_plan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"agri_work_plan_id"],[2,[7,"/"],[2,[6,"machine_work_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/agri_work_plans/agri_work_plan_show_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agri_work_plan_show_data_json_agri_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"agri_work_plan_show_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agri_work_plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agri_work_plans_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agri_work_plans"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json/agri_work_plans/agri_work_plans_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agri_work_plans_data_json_agri_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"agri_work_plans_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/machine_tasks/agri_work_plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agri_work_plans_json_machine_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"machine_tasks"],[2,[7,"/"],[2,[6,"agri_work_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agri_works_manager(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agri_works_manager_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agri_works_manager"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /agricultural_expertise/insect_pest_alerts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agricultural_expertise_insect_pest_alerts_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agricultural_expertise"],[2,[7,"/"],[2,[6,"insect_pest_alerts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agricultural_expertise/scout_report_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agricultural_expertise_scout_report_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agricultural_expertise"],[2,[7,"/"],[2,[6,"scout_report_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agro_experiments/photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agro_experiments_photos_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agro_experiments"],[2,[7,"/"],[2,[6,"photos"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agro_form/agro_operation_attributes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agro_form_agro_operation_attribute_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"agro_form"],[2,[7,"/"],[2,[6,"agro_operation_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agro_form/fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agro_form_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agro_form"],[2,[7,"/"],[2,[6,"fields"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/agri_work_plans/agro_operation_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agro_operation_data_json_agri_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"agro_operation_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/field_shapes/:id/agro_operation_mappings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agro_operation_mappings_json_field_shape_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"field_shapes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"agro_operation_mappings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/agro_operations/consolidated(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agro_operations_consolidated_report_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[6,"consolidated"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/agro_operations/consolidated(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agro_operations_consolidated_xlsx_report_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[6,"consolidated"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agri_works_manager/agro_operations_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agro_operations_data_agri_works_manager_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"agri_works_manager"],[2,[7,"/"],[2,[6,"agro_operations_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/scouting_tasks/agro_operations(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agro_operations_field_scouting_tasks_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"scouting_tasks"],[2,[7,"/"],[2,[6,"agro_operations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/vra_multitask_wizard/agro_operations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agro_operations_fields_vra_multitask_wizard_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[6,"vra_multitask_wizard"],[2,[7,"/"],[2,[6,"agro_operations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/machine_tasks/agro_operations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agro_operations_json_machine_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"machine_tasks"],[2,[7,"/"],[2,[6,"agro_operations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agro_operations_tracking(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agro_operations_tracking_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agro_operations_tracking"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json/field_shapes/:id/agro_operations_with_tracks(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agro_operations_with_tracks_json_field_shape_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"field_shapes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"agro_operations_with_tracks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agro_recommendations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agro_recommendation_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agro_recommendations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agro_recommendations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agro_recommendations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agro_recommendations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /agro_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agro_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agro_tasks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /agro_warehouse_stocks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agro_warehouse_stocks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agro_warehouse_stocks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /alert_reports/:constraint(.:format)
 * @param {any} constraint
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const alert_reports_path = /*#__PURE__*/ __route({"constraint":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"alert_reports"],[2,[7,"/"],[2,[3,"constraint"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /all_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const all_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"all_reports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /external_service_settings/fields/all_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const all_statuses_external_service_settings_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"external_service_settings"],[2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[6,"all_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /analytic_company_reports/crop_areas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_company_reports_crop_areas_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"analytic_company_reports"],[2,[7,"/"],[2,[6,"crop_areas"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /analytic_company_reports/crop_productivities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytic_company_reports_crop_productivities_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"analytic_company_reports"],[2,[7,"/"],[2,[6,"crop_productivities"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ao_chemical_usage_validations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ao_chemical_usage_validations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"ao_chemical_usage_validations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /approval_flows/:approval_flow_id(.:format)
 * @param {any} approval_flow_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approval_flow_path = /*#__PURE__*/ __route({"approval_flow_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"approval_flows"],[2,[7,"/"],[2,[3,"approval_flow_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /approval_flows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approval_flows_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"approval_flows"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /approval_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approval_request_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"approval_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /approval_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approval_requests_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"approval_requests"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /approval_flows/:approval_flow_id/approval_steps/:id(.:format)
 * @param {any} approval_flow_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approval_step_path = /*#__PURE__*/ __route({"approval_flow_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"approval_flows"],[2,[7,"/"],[2,[3,"approval_flow_id"],[2,[7,"/"],[2,[6,"approval_steps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /approval_flows/:approval_flow_id/approval_steps(.:format)
 * @param {any} approval_flow_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approval_steps_path = /*#__PURE__*/ __route({"approval_flow_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"approval_flows"],[2,[7,"/"],[2,[3,"approval_flow_id"],[2,[7,"/"],[2,[6,"approval_steps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /asset_checklist_item_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const asset_checklist_item_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"asset_checklist_item_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /asset_checklist_item_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const asset_checklist_item_types_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"asset_checklist_item_types"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /asset_checklist_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const asset_checklist_template_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"asset_checklist_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /asset_checklist_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const asset_checklist_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"asset_checklist_templates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /auth/agrimatics/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_agrimatics_authorize_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"agrimatics"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/claas_connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_claas_connect_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"claas_connect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/cnh(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_cnh_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"cnh"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agri_work_plans/:agri_work_plan_id/machine_work_plans/auto_fill(.:format)
 * @param {any} agri_work_plan_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_fill_agri_work_plan_machine_work_plans_path = /*#__PURE__*/ __route({"agri_work_plan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"agri_work_plan_id"],[2,[7,"/"],[2,[6,"machine_work_plans"],[2,[7,"/"],[2,[6,"auto_fill"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /automatic_notifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const automatic_notification_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"automatic_notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /automatic_notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const automatic_notifications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"automatic_notifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /automatic_scouting_tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const automatic_scouting_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"automatic_scouting_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /automatic_scouting_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const automatic_scouting_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"automatic_scouting_tasks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tickets/available_assignees(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const available_assignees_tickets_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[6,"available_assignees"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/machine_reports/available_machines_with_fuel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const available_machines_with_fuel_json_machine_reports_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"machine_reports"],[2,[7,"/"],[2,[6,"available_machines_with_fuel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /asset_checklist_templates/available_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const available_options_asset_checklist_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"asset_checklist_templates"],[2,[7,"/"],[2,[6,"available_options"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agri_works_manager/available_xlsx_columns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const available_xlsx_columns_agri_works_manager_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"agri_works_manager"],[2,[7,"/"],[2,[6,"available_xlsx_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_health_reports/:id/available_yield_maps(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const available_yield_maps_field_soil_health_report_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_health_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"available_yield_maps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /awp_chemical_usage_validations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const awp_chemical_usage_validations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"awp_chemical_usage_validations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /beet_cercospora_forecast(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const beet_cercospora_forecast_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"beet_cercospora_forecast"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /billing_details/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_detail_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billing_details"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billing_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_details_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"billing_details"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /bot_connections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bot_connection_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bot_connections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bot_connection_for_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bot_connection_for_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"bot_connection_for_users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /bot_connections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bot_connections_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"bot_connections"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /fields/cache_potential(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cache_potential_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[6,"cache_potential"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cadastral_land_parcels_imports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cadastral_land_parcels_imports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"cadastral_land_parcels_imports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json/excel_file_parsers/calibration_table_parse(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calibration_table_parse_json_excel_file_parsers_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"excel_file_parsers"],[2,[7,"/"],[2,[6,"calibration_table_parse"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /automatic_notifications/:id/change_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_status_automatic_notification_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"automatic_notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/iazs_service_sync_settings/check_domain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_domain_company_iazs_service_sync_settings_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"iazs_service_sync_settings"],[2,[7,"/"],[2,[6,"check_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/petroline_service_sync_settings/check_domain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_domain_company_petroline_service_sync_settings_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"petroline_service_sync_settings"],[2,[7,"/"],[2,[6,"check_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lpis_boundaries_imports/check_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_info_lpis_boundaries_imports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lpis_boundaries_imports"],[2,[7,"/"],[2,[6,"check_info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lpis_parcela_boundaries_imports/check_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_info_lpis_parcela_boundaries_imports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lpis_parcela_boundaries_imports"],[2,[7,"/"],[2,[6,"check_info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /upload_data/check/:type(.:format)
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_upload_data_path = /*#__PURE__*/ __route({"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"upload_data"],[2,[7,"/"],[2,[6,"check"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chemicals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chemical_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chemicals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /chemical_products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chemical_products_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"chemical_products"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /chemicals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chemicals_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"chemicals"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/application_tasks/:id/clone(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_field_application_task_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"application_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tickets/:id/close(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const close_ticket_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /closure_reasons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const closure_reason_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"closure_reasons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /closure_reasons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const closure_reasons_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"closure_reasons"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/vra_multilayers/clusterize/:layer_type(.:format)
 * @param {any} field_id
 * @param {any} layer_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clusterize_layer_field_vra_multilayers_path = /*#__PURE__*/ __route({"field_id":{"r":true},"layer_type":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"vra_multilayers"],[2,[7,"/"],[2,[6,"clusterize"],[2,[7,"/"],[2,[3,"layer_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/tasks/:id/colorized_track_sensors(.:format)
 * @param {any} machine_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const colorized_track_sensors_machine_machine_task_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"colorized_track_sensors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/accounting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_accounting_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"accounting"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/accounting_period_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_accounting_period_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"accounting_period_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/agrimatics_libra_cart/integration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_agrimatics_libra_cart_integration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"agrimatics_libra_cart"],[2,[7,"/"],[2,[6,"integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/benza_sync_settings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_benza_sync_setting_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"benza_sync_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/benza_sync_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_benza_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"benza_sync_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/claas_connect_service_sync_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_claas_connect_service_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"claas_connect_service_sync_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/cnh_service_sync_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_cnh_service_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"cnh_service_sync_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/exatrek_service_sync_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_exatrek_service_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"exatrek_service_sync_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/field_groups_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_field_groups_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"field_groups_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/horsch_service_sync_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_horsch_service_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"horsch_service_sync_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/iazs_service_sync_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_iazs_service_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"iazs_service_sync_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/identity_providers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_identity_provider_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"identity_providers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/identity_providers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_identity_providers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"identity_providers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/identity_providers/adfs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_identity_providers_adfs_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"identity_providers"],[2,[7,"/"],[2,[6,"adfs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/land_document_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_land_document_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"land_document_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/land_intersection_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_land_intersection_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"land_intersection_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/my_geo_tab_sync_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_my_geo_tab_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"my_geo_tab_sync_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/my_john_deere_service_sync_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_my_john_deere_service_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"my_john_deere_service_sync_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/okko_sync_settings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_okko_sync_setting_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"okko_sync_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/okko_sync_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_okko_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"okko_sync_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/orwii_sync_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_orwii_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"orwii_sync_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/pagro_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_pagro_subscriptions_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"pagro_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/petroline_service_sync_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_petroline_service_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"petroline_service_sync_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company_planet_subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_planet_subscription_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company_planet_subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company_planet_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_planet_subscriptions_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company_planet_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /company/positrace_sync_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_positrace_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"positrace_sync_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/precision_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_precision_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"precision_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/product_plus(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_product_plus_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"product_plus"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/raven_service_sync_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_raven_service_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"raven_service_sync_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/report_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_report_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"report_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/rompetrol_service_sync_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_rompetrol_service_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"rompetrol_service_sync_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/scout_report_security(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_scout_report_security_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"scout_report_security"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/two_factor_policy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_two_factor_policy_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"two_factor_policy"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/valley_service_sync_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_valley_service_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"valley_service_sync_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/webdispecink_sync_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_webdispecink_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"webdispecink_sync_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/wog_sync_settings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_wog_sync_setting_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"wog_sync_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/wog_sync_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_wog_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"wog_sync_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/yara_service_sync_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_yara_service_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"yara_service_sync_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machines/consolidated_export_to_excel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consolidated_export_to_excel_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"consolidated_export_to_excel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/scout_reports/consolidated_far(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consolidated_far_xlsx_report_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"scout_reports"],[2,[7,"/"],[2,[6,"consolidated_far"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /consultation_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consultation_request_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"consultation_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /consultation_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consultation_requests_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"consultation_requests"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /counterparties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const counterparties_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"counterparties"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /counterparties/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const counterparty_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"counterparties"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /counterparty_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const counterparty_group_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"counterparty_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /counterparty_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const counterparty_groups_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"counterparty_groups"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /country_crops_map/find_geometry(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const country_crops_map_find_geometry_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"country_crops_map"],[2,[7,"/"],[2,[6,"find_geometry"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /country_fields_map(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const country_fields_map_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"country_fields_map"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /country_fields_map/selected_year_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const country_fields_map_selected_year_data_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"country_fields_map"],[2,[7,"/"],[2,[6,"selected_year_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /create_agro_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_agro_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"create_agro_tasks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /company_planet_subscriptions/create_bunch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_bunch_company_planet_subscriptions_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company_planet_subscriptions"],[2,[7,"/"],[2,[6,"create_bunch"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lpis_field_and_plot_boundaries_imports/create_fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_fields_lpis_field_and_plot_boundaries_imports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lpis_field_and_plot_boundaries_imports"],[2,[7,"/"],[2,[6,"create_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/as_applied_maps/create_multiple(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_multiple_field_as_applied_maps_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"as_applied_maps"],[2,[7,"/"],[2,[6,"create_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/yield_maps/create_multiple(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_multiple_field_yield_maps_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"yield_maps"],[2,[7,"/"],[2,[6,"create_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /plots/:id/plot_rows(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_plot_rows_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"plots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"plot_rows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_health_reports/:id/create_soil_test_task(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_soil_test_task_field_soil_health_report_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_health_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_soil_test_task"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /plant_threats/create_standard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_standard_plant_threats_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"plant_threats"],[2,[7,"/"],[2,[6,"create_standard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machines/create_tasks_by_schedule(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_tasks_by_schedule_machines_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"create_tasks_by_schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machines/create_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_tasks_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"create_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /crops/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const crop_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"crops"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /crop_advisor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const crop_advisor_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"crop_advisor"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /crop_condition_assessments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const crop_condition_assessments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"crop_condition_assessments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /crop_rotation(/:show_all)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const crop_rotation_path = /*#__PURE__*/ __route({"show_all":{},"format":{}}, [2,[7,"/"],[2,[6,"crop_rotation"],[2,[1,[2,[7,"/"],[3,"show_all"]]],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /crop_rotation/autofill(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const crop_rotation_autofill_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"crop_rotation"],[2,[7,"/"],[2,[6,"autofill"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /crop_rotation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const crop_rotation_post_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"crop_rotation"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /crops(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const crops_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"crops"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /implements/:implement_id/odometer_states/current(.:format)
 * @param {any} implement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const current_implement_odometer_states_path = /*#__PURE__*/ __route({"implement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"implements"],[2,[7,"/"],[2,[3,"implement_id"],[2,[7,"/"],[2,[6,"odometer_states"],[2,[7,"/"],[2,[6,"current"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/odometer_states/current(.:format)
 * @param {any} machine_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const current_machine_odometer_states_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"odometer_states"],[2,[7,"/"],[2,[6,"current"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /json/fields/:id/current_shape(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const current_shape_json_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"current_shape"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /gps_loggers/custom_fields_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_fields_data_gps_loggers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"gps_loggers"],[2,[7,"/"],[2,[6,"custom_fields_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cwo_gpt/chats/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cwo_gpt_chat_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cwo_gpt"],[2,[7,"/"],[2,[6,"chats"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cwo_gpt/chat_actions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cwo_gpt_chat_action_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cwo_gpt"],[2,[7,"/"],[2,[6,"chat_actions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cwo_gpt/chats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cwo_gpt_chats_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"cwo_gpt"],[2,[7,"/"],[2,[6,"chats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cwo_gpt/feedbacks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cwo_gpt_feedback_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cwo_gpt"],[2,[7,"/"],[2,[6,"feedbacks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cwo_gpt/feedbacks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cwo_gpt_feedbacks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"cwo_gpt"],[2,[7,"/"],[2,[6,"feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cwo_gpt(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cwo_gpt_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"cwo_gpt"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cwo_gpt/sse_stream(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cwo_gpt_sse_stream_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"cwo_gpt"],[2,[7,"/"],[2,[6,"sse_stream"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cwo_gpt/transcribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cwo_gpt_transcribe_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"cwo_gpt"],[2,[7,"/"],[2,[6,"transcribe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /d/users/adfs_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const d_users_adfs_statuses_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"d"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"adfs_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/daily_plan_to_excel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const daily_plan_to_excel_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"daily_plan_to_excel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fields/:id/dashboard_charts_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_charts_data_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dashboard_charts_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:id/dashboards/crop_cycle_field_info(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboards_crop_cycle_field_info_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"crop_cycle_field_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:id/dashboards/histogram/download_pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboards_histogram_download_pdf_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"histogram"],[2,[7,"/"],[2,[6,"download_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:id/dashboards/histogram(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboards_histogram_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"histogram"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:id/dashboards/monitoring(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboards_monitoring_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"monitoring"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:id/dashboards/monitoring(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboards_monitoring_machine_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"monitoring"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:id/dashboards/ndvi_contrast_scale(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboards_ndvi_contrast_scale_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"ndvi_contrast_scale"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:id/dashboards/satellite_images(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboards_satellite_images_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"satellite_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /json/agri_work_plans/data_for_delete_plan(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_for_delete_plan_json_agri_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"data_for_delete_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/manual_work_plans/data_for_delete_plan(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_for_delete_plan_json_manual_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"manual_work_plans"],[2,[7,"/"],[2,[6,"data_for_delete_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/manual_tasks/data_for_delete_task(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_for_delete_task_json_manual_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"manual_tasks"],[2,[7,"/"],[2,[6,"data_for_delete_task"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /data_source_parameter_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_source_parameter_template_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"data_source_parameter_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /data_source_parameter_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_source_parameter_templates_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"data_source_parameter_templates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /platform/deck_of_apps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deck_of_apps_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"platform"],[2,[7,"/"],[2,[6,"deck_of_apps"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/agro_operations/delete_agro_operations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_agro_operations_json_agro_operations_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[6,"delete_agro_operations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/alerts/delete_alerts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_alerts_json_alerts_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"alerts"],[2,[7,"/"],[2,[6,"delete_alerts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/manual_work_plan_items/delete_manual_work_plan_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_manual_work_plan_items_json_manual_work_plan_items_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"manual_work_plan_items"],[2,[7,"/"],[2,[6,"delete_manual_work_plan_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/agro_operations/destroy_batch(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_batch_field_agro_operations_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[6,"destroy_batch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/skyfms_sync_settings/:id/destroy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_company_skyfms_sync_settings_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"skyfms_sync_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/webdispecink_sync_settings/:id/destroy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_company_webdispecink_sync_settings_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"webdispecink_sync_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fuel_inventory_documents/:id/destroy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_fuel_inventory_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fuel_inventory_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/agro_operations/detach_from_agri_work_plan_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detach_from_agri_work_plan_info_json_agro_operations_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[6,"detach_from_agri_work_plan_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/agro_operations/detach_from_agri_work_plan(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detach_from_agri_work_plan_json_agro_operations_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[6,"detach_from_agri_work_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /detecting_weedy_fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detecting_weedy_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"detecting_weedy_fields"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /direction_lines(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const direction_lines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"direction_lines"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /session_variables/dont_show_again(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dont_show_again_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"session_variables"],[2,[7,"/"],[2,[6,"dont_show_again"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agro_operations_tracking/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_agro_operations_tracking_index_path = /*#__PURE__*/ __route({"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"agro_operations_tracking"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/agro_operations/:id/download_ami_by_days_report(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_ami_by_days_report_field_agro_operation_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_ami_by_days_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /new_awp_design/agri_work_plans/:id/download_apk_420_report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_apk_420_report_new_awp_design_agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_awp_design"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_apk_420_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /new_awp_design/agri_work_plans/:id/download_awp_sp_13_sheet_report_list(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_awp_sp_13_sheet_report_list_new_awp_design_agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_awp_design"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_awp_sp_13_sheet_report_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /crop_condition_assessments/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_crop_condition_assessments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"crop_condition_assessments"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /monitoring_crop_stress/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_crop_stress_recommendations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"monitoring_crop_stress"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /download_geo_raster_images/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_geo_raster_images_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"download_geo_raster_images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /gps_loggers/:id/history(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_history_gps_logger_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gps_loggers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /insects_monitoring_service/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_insects_monitoring_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"insects_monitoring_service"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /inventory_tracking/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_inventory_tracking_index_path = /*#__PURE__*/ __route({"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"inventory_tracking"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /download_land_parcel/:id/:shape_format(.:format)
 * @param {any} id
 * @param {any} shape_format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_land_parcel_path = /*#__PURE__*/ __route({"id":{"r":true},"shape_format":{"r":true,"d":"json"},"format":{}}, [2,[7,"/"],[2,[6,"download_land_parcel"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"shape_format"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /download_land_parcels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_land_parcels_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"download_land_parcels"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /download_map_soil_tests_xlsx(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_map_soil_tests_xlsx_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"download_map_soil_tests_xlsx"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /crop_condition_assessments/download_pdf(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_pdf_crop_condition_assessments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"crop_condition_assessments"],[2,[7,"/"],[2,[6,"download_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /protected_documents/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_protected_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"protected_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reduced_seeding_rate_recommendation/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_reduced_seeding_rate_recommendations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reduced_seeding_rate_recommendation"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /manual_work_plans/download_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_report_manual_work_plans_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"manual_work_plans"],[2,[7,"/"],[2,[6,"download_report"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /new_awp_design/agri_work_plans/download_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_report_new_awp_design_agri_work_plans_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"new_awp_design"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"download_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sdhi_fungicides_recommendation/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_sdhi_fungicides_recommendations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"sdhi_fungicides_recommendation"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /new_awp_design/agri_work_plans/:id/download_seed_consumption_report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_seed_consumption_report_new_awp_design_agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_awp_design"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_seed_consumption_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /seeds_moisture_tracking/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_seeds_moisture_tracking_index_path = /*#__PURE__*/ __route({"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"seeds_moisture_tracking"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /special_crops_monitoring_service/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_special_crops_monitoring_service_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"special_crops_monitoring_service"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /target_ndvi_monitoring/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_target_ndvi_monitoring_index_path = /*#__PURE__*/ __route({"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"target_ndvi_monitoring"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/agro_operations/:id/download_vzsg_fertilizer_act(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_vzsg_fertilizer_act_field_agro_operation_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_vzsg_fertilizer_act"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /new_awp_design/agri_work_plans/:id/download_vzsg_fertilizer_act(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_vzsg_fertilizer_act_new_awp_design_agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_awp_design"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_vzsg_fertilizer_act"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /weedy_fields_monitoring/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_weedy_fields_monitoring_index_path = /*#__PURE__*/ __route({"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"weedy_fields_monitoring"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ndvi_histogram_of_fields/download_xlsx(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_xlsx_ndvi_histogram_of_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"ndvi_histogram_of_fields"],[2,[7,"/"],[2,[6,"download_xlsx"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /download_company_weather(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloads_company_weather_path = /*#__PURE__*/ __route({"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"download_company_weather"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /download_gps_track/:download_type(/:id)/:format(.:format)
 * @param {any} download_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloads_gps_track_path = /*#__PURE__*/ __route({"download_type":{"r":true},"id":{},"format":{}}, [2,[7,"/"],[2,[6,"download_gps_track"],[2,[7,"/"],[2,[3,"download_type"],[2,[1,[2,[7,"/"],[3,"id"]]],[2,[7,"/"],[2,[3,"format"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /download_weather(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloads_weather_path = /*#__PURE__*/ __route({"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"download_weather"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /drivers_performance_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drivers_performance_report_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"drivers_performance_report"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /agri_work_plans/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /new_awp_design/agri_work_plans/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_new_awp_design_agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_awp_design"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agri_work_plans/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agri_work_plans/:agri_work_plan_id/machine_work_plans/:id/edit(.:format)
 * @param {any} agri_work_plan_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_agri_work_plan_machine_work_plan_path = /*#__PURE__*/ __route({"agri_work_plan_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"agri_work_plan_id"],[2,[7,"/"],[2,[6,"machine_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /new_awp_design/agri_work_plans/:id/edit_agro_operations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_agro_operations_new_awp_design_agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_awp_design"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_agro_operations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /automatic_notifications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_automatic_notification_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"automatic_notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /automatic_scouting_tasks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_automatic_scouting_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"automatic_scouting_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billing_details/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_billing_detail_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billing_details"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /closure_reasons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_closure_reason_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"closure_reasons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/accounting/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_accounting_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"accounting"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/accounting_period_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_accounting_period_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"accounting_period_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/benza_sync_settings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_benza_sync_setting_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"benza_sync_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/exatrek_service_sync_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_exatrek_service_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"exatrek_service_sync_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/field_groups_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_field_groups_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"field_groups_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/horsch_service_sync_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_horsch_service_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"horsch_service_sync_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/iazs_service_sync_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_iazs_service_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"iazs_service_sync_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/identity_providers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_identity_provider_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"identity_providers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/my_geo_tab_sync_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_my_geo_tab_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"my_geo_tab_sync_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/my_john_deere_service_sync_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_my_john_deere_service_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"my_john_deere_service_sync_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/okko_sync_settings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_okko_sync_setting_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"okko_sync_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/orwii_sync_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_orwii_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"orwii_sync_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/petroline_service_sync_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_petroline_service_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"petroline_service_sync_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company_planet_subscriptions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_planet_subscription_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company_planet_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/positrace_sync_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_positrace_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"positrace_sync_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/product_plus/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_product_plus_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"product_plus"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/rompetrol_service_sync_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_rompetrol_service_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"rompetrol_service_sync_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/scout_report_security/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_scout_report_security_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"scout_report_security"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/security/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_security_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/valley_service_sync_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_valley_service_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"valley_service_sync_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/webdispecink_sync_settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_webdispecink_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"webdispecink_sync_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/wog_sync_settings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_wog_sync_setting_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"wog_sync_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /counterparty_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_counterparty_group_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"counterparty_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /custom_fields_dropdown_items/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_custom_fields_dropdown_item_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom_fields_dropdown_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /external_service_settings/fields/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_external_service_settings_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_service_settings"],[2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_service_settings/field_items/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_external_service_settings_field_item_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_service_settings"],[2,[7,"/"],[2,[6,"field_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/agro_operations/:id/edit(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_field_agro_operation_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /field_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_field_group_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"field_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/crop_rotation/:id/edit(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_field_history_item_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"crop_rotation"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/leaf_tests/:id/edit(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_field_leaf_test_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"leaf_tests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/manual_tasks/:id/edit(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_field_manual_task_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"manual_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_health_reports/:id/edit(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_field_soil_health_report_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_health_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_tests/:id/edit(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_field_soil_test_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_tests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/vra_multilayers/:id/edit(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_field_vra_multilayer_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"vra_multilayers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/automatic_alerts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_fields_automatic_alert_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[6,"automatic_alerts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /financial_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_financial_category_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"financial_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/history_items/:id/edit_form_props(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_form_props_json_history_item_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"history_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_form_props"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fuel_inventory_documents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_fuel_inventory_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fuel_inventory_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fuel_stations/:fuel_station_id/fuel_movements/:id/edit(.:format)
 * @param {any} fuel_station_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_fuel_station_fuel_movement_path = /*#__PURE__*/ __route({"fuel_station_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fuel_stations"],[2,[7,"/"],[2,[3,"fuel_station_id"],[2,[7,"/"],[2,[6,"fuel_movements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fuel_tanks/:fuel_tank_id/fuel_movements/:id/edit(.:format)
 * @param {any} fuel_tank_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_fuel_tank_fuel_movement_path = /*#__PURE__*/ __route({"fuel_tank_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fuel_tanks"],[2,[7,"/"],[2,[3,"fuel_tank_id"],[2,[7,"/"],[2,[6,"fuel_movements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fuel_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_fuel_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fuel_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /implements/:implement_id/implement_sensors/:id/edit(.:format)
 * @param {any} implement_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_implement_implement_sensor_path = /*#__PURE__*/ __route({"implement_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"implements"],[2,[7,"/"],[2,[3,"implement_id"],[2,[7,"/"],[2,[6,"implement_sensors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /implements/:implement_id/maintenance_records/:id/edit(.:format)
 * @param {any} implement_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_implement_maintenance_record_path = /*#__PURE__*/ __route({"implement_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"implements"],[2,[7,"/"],[2,[3,"implement_id"],[2,[7,"/"],[2,[6,"maintenance_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /implements/:implement_id/odometer_states/:id/edit(.:format)
 * @param {any} implement_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_implement_odometer_state_path = /*#__PURE__*/ __route({"implement_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"implements"],[2,[7,"/"],[2,[3,"implement_id"],[2,[7,"/"],[2,[6,"odometer_states"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /issue_wh_documents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_issue_wh_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"issue_wh_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /land_documents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_land_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"land_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /local_communities/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_local_community_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"local_communities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/fuel_movements/:id/edit(.:format)
 * @param {any} machine_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_machine_fuel_movement_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"fuel_movements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machine_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_machine_group_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machine_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/harvest_weighings/:id/edit(.:format)
 * @param {any} machine_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_machine_harvest_weighing_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"harvest_weighings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/maintenance_records/:id/edit(.:format)
 * @param {any} machine_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_machine_maintenance_record_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"maintenance_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/odometer_states/:id/edit(.:format)
 * @param {any} machine_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_machine_odometer_state_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"odometer_states"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machine_regions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_machine_region_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machine_regions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machinery_manufacturers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_machinery_manufacturer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machinery_manufacturers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machinery_models/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_machinery_model_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machinery_models"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /maintenance_plans/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_maintenance_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"maintenance_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /manual_tasks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_manual_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manual_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /manual_work_plans/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_manual_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manual_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /manual_work_plans/:id/edit_manual_work_plan_items(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_manual_work_plan_items_manual_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manual_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_manual_work_plan_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:applicable_type/mass_changes_ami/:id/edit(.:format)
 * @param {any} applicable_type
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_mass_changes_ami_path = /*#__PURE__*/ __route({"applicable_type":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"applicable_type"],[2,[7,"/"],[2,[6,"mass_changes_ami"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /new_awp_design/agri_work_plans/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_new_awp_design_agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_awp_design"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orchard_crops/:orchard_crop_id/orchard_varieties/:id/edit(.:format)
 * @param {any} orchard_crop_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_orchard_crop_orchard_variety_path = /*#__PURE__*/ __route({"orchard_crop_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orchard_crops"],[2,[7,"/"],[2,[3,"orchard_crop_id"],[2,[7,"/"],[2,[6,"orchard_varieties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /personal_identifiers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_personal_identifier_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"personal_identifiers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /personal_identifiers/:personal_identifier_id/equipment_assignments/:id/edit(.:format)
 * @param {any} personal_identifier_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_personal_identifier_equipment_assignment_path = /*#__PURE__*/ __route({"personal_identifier_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"personal_identifiers"],[2,[7,"/"],[2,[3,"personal_identifier_id"],[2,[7,"/"],[2,[6,"equipment_assignments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pivots/:pivot_id/field_mappings/:id/edit(.:format)
 * @param {any} pivot_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_pivot_pivot_field_mapping_path = /*#__PURE__*/ __route({"pivot_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pivots"],[2,[7,"/"],[2,[3,"pivot_id"],[2,[7,"/"],[2,[6,"field_mappings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /plant_threats/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_plant_threat_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"plant_threats"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /plots/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_plot_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"plots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /plots/:id/plot_rows/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_plot_rows_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"plots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"plot_rows"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /production_cycles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_production_cycle_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"production_cycles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /receipt_wh_documents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_receipt_wh_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"receipt_wh_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /registered_fields/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_registered_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registered_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /registered_fields/:registered_field_id/shapes/:id/edit(.:format)
 * @param {any} registered_field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_registered_field_registered_field_shape_path = /*#__PURE__*/ __route({"registered_field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registered_fields"],[2,[7,"/"],[2,[3,"registered_field_id"],[2,[7,"/"],[2,[6,"shapes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /scout_report_templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_scout_report_template_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scout_report_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scouting_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_scouting_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scouting_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /seasons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_season_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /seeds/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_seed_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"seeds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sharing_data_platform/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_sharing_data_platform_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sharing_data_platform"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spare_parts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_spare_part_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spare_parts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /transfer_wh_documents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_transfer_wh_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"transfer_wh_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/legend_scales/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_legend_scale_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"legend_scales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_roles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_role_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /warehouse_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_warehouse_group_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"warehouse_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /wh_item_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_wh_item_group_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wh_item_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /work_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_work_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"work_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /work_type_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_work_type_group_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"work_type_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /field_shapes_downloads/download_efis_shp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const efis_shp_field_shapes_downloads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"field_shapes_downloads"],[2,[7,"/"],[2,[6,"download_efis_shp"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /personal_identifiers/equipment_holders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipment_holders_personal_identifiers_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"personal_identifiers"],[2,[7,"/"],[2,[6,"equipment_holders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /chemicals/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_chemicals_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"chemicals"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fertilizers/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_fertilizers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fertilizers"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/application_tasks/:id/export(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_field_application_task_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"application_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_tests/export(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_field_soil_tests_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_tests"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fuel_types/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_fuel_types_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fuel_types"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /plant_threat_scores/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_plant_threat_scores_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"plant_threat_scores"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /seeds/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_seeds_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"seeds"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /spare_parts/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_spare_parts_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"spare_parts"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machines/export_to_excel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_to_excel_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"export_to_excel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /wh_items/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_wh_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"wh_items"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /equipment_assignments/external_id_check_availability(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_id_check_availability_equipment_assignments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"equipment_assignments"],[2,[7,"/"],[2,[6,"external_id_check_availability"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fuel_inventory_documents/external_id_check_availability(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_id_check_availability_fuel_inventory_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fuel_inventory_documents"],[2,[7,"/"],[2,[6,"external_id_check_availability"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fuel_pumps/external_id_check_availability(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_id_check_availability_fuel_pumps_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fuel_pumps"],[2,[7,"/"],[2,[6,"external_id_check_availability"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fuel_stations/external_id_check_availability(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_id_check_availability_fuel_stations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fuel_stations"],[2,[7,"/"],[2,[6,"external_id_check_availability"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fuel_tanks/external_id_check_availability(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_id_check_availability_fuel_tanks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fuel_tanks"],[2,[7,"/"],[2,[6,"external_id_check_availability"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fuel_types/external_id_check_availability(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_id_check_availability_fuel_types_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fuel_types"],[2,[7,"/"],[2,[6,"external_id_check_availability"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /personal_identifiers/external_id_check_availability(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_id_check_availability_personal_identifiers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"personal_identifiers"],[2,[7,"/"],[2,[6,"external_id_check_availability"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /external_service_settings/fields/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_service_settings_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_service_settings"],[2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /external_service_settings/fields_insurance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_service_settings_fields_insurance_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"external_service_settings"],[2,[7,"/"],[2,[6,"fields_insurance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /external_service_settings/import_mjd/:type(.:format)
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_service_settings_import_mjd_path = /*#__PURE__*/ __route({"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_service_settings"],[2,[7,"/"],[2,[6,"import_mjd"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /external_service_settings/import_mjd/organization_fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_service_settings_import_mjd_organization_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"external_service_settings"],[2,[7,"/"],[2,[6,"import_mjd"],[2,[7,"/"],[2,[6,"organization_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /external_service_settings/import_mjd(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_service_settings_import_mjd_wizard_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"external_service_settings"],[2,[7,"/"],[2,[6,"import_mjd"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /external_service_settings/my_john_deere_fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_service_settings_my_john_deere_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"external_service_settings"],[2,[7,"/"],[2,[6,"my_john_deere_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /external_service_settings/my_john_deere_sync_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_service_settings_my_john_deere_sync_report_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"external_service_settings"],[2,[7,"/"],[2,[6,"my_john_deere_sync_report"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agri_work_plans/:agri_work_plan_id/machine_work_plans/fact_rate(.:format)
 * @param {any} agri_work_plan_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fact_rate_agri_work_plan_machine_work_plans_path = /*#__PURE__*/ __route({"agri_work_plan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"agri_work_plan_id"],[2,[7,"/"],[2,[6,"machine_work_plans"],[2,[7,"/"],[2,[6,"fact_rate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fertilizers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fertilizer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fertilizers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fertilizers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fertilizers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fertilizers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /lpis_field_and_plot_boundaries_imports/fetch_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fetch_data_lpis_field_and_plot_boundaries_imports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lpis_field_and_plot_boundaries_imports"],[2,[7,"/"],[2,[6,"fetch_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fields/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/agro_experiments/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_agro_experiment_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"agro_experiments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/agro_experiments(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_agro_experiments_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"agro_experiments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/agro_operations/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_agro_operation_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/agro_operations(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_agro_operations_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"agro_operations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/alerts/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_alert_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"alerts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/application_tasks/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_application_task_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"application_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/application_tasks(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_application_tasks_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"application_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/as_applied_maps/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_as_applied_map_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"as_applied_maps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/as_applied_maps(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_as_applied_maps_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"as_applied_maps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /special_crops_monitoring_service/field_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_data_special_crops_monitoring_service_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"special_crops_monitoring_service"],[2,[7,"/"],[2,[6,"field_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/direction_lines/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_direction_line_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"direction_lines"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/direction_lines(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_direction_lines_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"direction_lines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /field_expense_widget(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_expense_widget_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"field_expense_widget"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/scout_reports/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_field_scout_report_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"scout_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/scout_reports/:field_scout_report_id/points/:scout_report_point_id/growth_stage_structures/:id(.:format)
 * @param {any} field_id
 * @param {any} field_scout_report_id
 * @param {any} scout_report_point_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_field_scout_report_scout_report_point_scout_report_point_growth_stage_structure_path = /*#__PURE__*/ __route({"field_id":{"r":true},"field_scout_report_id":{"r":true},"scout_report_point_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"scout_reports"],[2,[7,"/"],[2,[3,"field_scout_report_id"],[2,[7,"/"],[2,[6,"points"],[2,[7,"/"],[2,[3,"scout_report_point_id"],[2,[7,"/"],[2,[6,"growth_stage_structures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/scout_reports/:field_scout_report_id/points/:scout_report_point_id/growth_stage_structures(.:format)
 * @param {any} field_id
 * @param {any} field_scout_report_id
 * @param {any} scout_report_point_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_field_scout_report_scout_report_point_scout_report_point_growth_stage_structures_path = /*#__PURE__*/ __route({"field_id":{"r":true},"field_scout_report_id":{"r":true},"scout_report_point_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"scout_reports"],[2,[7,"/"],[2,[3,"field_scout_report_id"],[2,[7,"/"],[2,[6,"points"],[2,[7,"/"],[2,[3,"scout_report_point_id"],[2,[7,"/"],[2,[6,"growth_stage_structures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/scout_reports(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_field_scout_reports_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"scout_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/shapes/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_field_shape_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"shapes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/shapes(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_field_shapes_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"shapes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /automatic_scouting_task_form/agronomists/field_group_responsibles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_group_responsibles_automatic_scouting_task_form_agronomists_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"automatic_scouting_task_form"],[2,[7,"/"],[2,[6,"agronomists"],[2,[7,"/"],[2,[6,"field_group_responsibles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/growth_stages_prediction/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_growth_stages_prediction_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"growth_stages_prediction"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/harvest_indicators/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_harvest_indicator_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"harvest_indicators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/harvest_indicators(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_harvest_indicators_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"harvest_indicators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/crop_rotation/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_history_item_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"crop_rotation"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/crop_rotation/:history_item_id/orchard_attributes/:id(.:format)
 * @param {any} field_id
 * @param {any} history_item_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_history_item_orchard_attribute_path = /*#__PURE__*/ __route({"field_id":{"r":true},"history_item_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"crop_rotation"],[2,[7,"/"],[2,[3,"history_item_id"],[2,[7,"/"],[2,[6,"orchard_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/crop_rotation(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_history_items_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"crop_rotation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/import_vra_tasks(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_import_vra_tasks_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"import_vra_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/history/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_inventory_history_item_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"history"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/history(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_inventory_history_items_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/leaf_tests/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_leaf_test_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"leaf_tests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/leaf_tests(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_leaf_tests_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"leaf_tests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/manual_tasks/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_manual_task_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"manual_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/manual_tasks(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_manual_tasks_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"manual_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/manual_work_plan_items/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_manual_work_plan_item_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"manual_work_plan_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /json/agri_work_plans/field_map_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_map_data_json_agri_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"field_map_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/ndvi_images(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_ndvi_images_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"ndvi_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/ndvi_vra_zoning(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_ndvi_vra_zoning_index_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"ndvi_vra_zoning"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/nutrition_plans/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_nutrition_plan_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"nutrition_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/nutrition_plans/:nutrition_plan_id/create_consultation_request(.:format)
 * @param {any} field_id
 * @param {any} nutrition_plan_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_nutrition_plan_create_consultation_request_path = /*#__PURE__*/ __route({"field_id":{"r":true},"nutrition_plan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"nutrition_plans"],[2,[7,"/"],[2,[3,"nutrition_plan_id"],[2,[7,"/"],[2,[6,"create_consultation_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/nutrition_plans(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_nutrition_plans_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"nutrition_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/planet_subscriptions(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_planet_subscriptions_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"planet_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/productivity_images(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_productivity_images_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"productivity_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /automatic_scouting_task_form/agronomists/field_responsibles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_responsibles_automatic_scouting_task_form_agronomists_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"automatic_scouting_task_form"],[2,[7,"/"],[2,[6,"agronomists"],[2,[7,"/"],[2,[6,"field_responsibles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/scouting_tasks/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_scouting_task_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"scouting_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/scouting_tasks(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_scouting_tasks_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"scouting_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/land_parcels/field_shape_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_shape_options_json_land_parcels_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"land_parcels"],[2,[7,"/"],[2,[6,"field_shape_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_health_reports/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_soil_health_report_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_health_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_health_reports(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_soil_health_reports_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_health_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_tests/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_soil_test_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_tests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_test_tasks/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_soil_test_task_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_test_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_test_tasks/:soil_test_task_id/export(.:format)
 * @param {any} field_id
 * @param {any} soil_test_task_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_soil_test_task_export_path = /*#__PURE__*/ __route({"field_id":{"r":true},"soil_test_task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_test_tasks"],[2,[7,"/"],[2,[3,"soil_test_task_id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_test_tasks/:soil_test_task_id/export_image(.:format)
 * @param {any} field_id
 * @param {any} soil_test_task_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_soil_test_task_export_image_path = /*#__PURE__*/ __route({"field_id":{"r":true},"soil_test_task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_test_tasks"],[2,[7,"/"],[2,[3,"soil_test_task_id"],[2,[7,"/"],[2,[6,"export_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_test_tasks(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_soil_test_tasks_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_test_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_tests(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_soil_tests_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_tests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_texture_maps/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_soil_texture_map_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_texture_maps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_texture_maps(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_soil_texture_maps_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_texture_maps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/visible_vra_zoning(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_visible_vra_zoning_index_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"visible_vra_zoning"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/vra_multilayers/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_vra_multilayer_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"vra_multilayers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/vra_multilayers(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_vra_multilayers_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"vra_multilayers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/vra_soil_tests(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_vra_soil_tests_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"vra_soil_tests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/yield_maps/:id(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_yield_map_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"yield_maps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/yield_maps(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_yield_maps_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"yield_maps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fields"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /fields/consolidated(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fields_consolidated_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[6,"consolidated"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shapes_uploads/fields_data_check/:type(.:format)
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fields_data_check_shapes_uploads_path = /*#__PURE__*/ __route({"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shapes_uploads"],[2,[7,"/"],[2,[6,"fields_data_check"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/agri_work_plans/fields_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fields_data_json_agri_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"fields_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/manual_work_plans/fields_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fields_data_json_manual_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"manual_work_plans"],[2,[7,"/"],[2,[6,"fields_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/downloads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fields_downloads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[6,"downloads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/agri_work_plans/fields_filter_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fields_filter_data_json_agri_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"fields_filter_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/manual_work_plans/fields_filter_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fields_filter_data_json_manual_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"manual_work_plans"],[2,[7,"/"],[2,[6,"fields_filter_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/machine_tasks/fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fields_json_machine_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"machine_tasks"],[2,[7,"/"],[2,[6,"fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pivots/fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fields_pivots_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pivots"],[2,[7,"/"],[2,[6,"fields"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fields/plant_threat_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fields_plant_threat_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[6,"plant_threat_items"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /special_crops_monitoring_service/fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fields_special_crops_monitoring_service_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"special_crops_monitoring_service"],[2,[7,"/"],[2,[6,"fields"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fields/vegetation_history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fields_vegetation_history_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[6,"vegetation_history"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fields/vra_multitask_wizard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fields_vra_multitask_wizard_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[6,"vra_multitask_wizard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agri_works_manager/filter_options_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filter_options_data_agri_works_manager_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"agri_works_manager"],[2,[7,"/"],[2,[6,"filter_options_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /filter_presets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filter_preset_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"filter_presets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /filter_presets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filter_presets_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"filter_presets"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json/agri_work_plans/filters_options_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filters_options_data_json_agri_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"filters_options_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/manual_tasks/filters_options_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filters_options_data_json_manual_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"manual_tasks"],[2,[7,"/"],[2,[6,"filters_options_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/manual_work_plans/filters_options_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filters_options_data_json_manual_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"manual_work_plans"],[2,[7,"/"],[2,[6,"filters_options_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /financial_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const financial_categories_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"financial_categories"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /financial_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const financial_category_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"financial_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/finish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finish_event_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"finish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /field_scout_report_photos_bunch_uploading/field_form_props(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fsr_bunch_upload_field_form_props_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"field_scout_report_photos_bunch_uploading"],[2,[7,"/"],[2,[6,"field_form_props"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /field_scout_report_photos_bunch_uploading/map_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fsr_bunch_upload_map_data_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"field_scout_report_photos_bunch_uploading"],[2,[7,"/"],[2,[6,"map_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /field_scout_report_photos_bunch_uploading/:uuid/reports(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fsr_bunch_upload_reports_path = /*#__PURE__*/ __route({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"field_scout_report_photos_bunch_uploading"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /field_scout_report_photos_bunch_uploading/:uuid/undetected(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fsr_bunch_upload_undetected_path = /*#__PURE__*/ __route({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"field_scout_report_photos_bunch_uploading"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"undetected"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fuel_inventory_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fuel_inventory_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fuel_inventory_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fuel_inventory_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fuel_inventory_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fuel_inventory_documents"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /fuel_inventory_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fuel_inventory_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fuel_inventory_reports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /fuel_movements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fuel_movement_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fuel_movements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fuel_movements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fuel_movements_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fuel_movements"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json/machine_tasks/fuel_movements_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fuel_movements_data_json_machine_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"machine_tasks"],[2,[7,"/"],[2,[6,"fuel_movements_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fuel_stations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fuel_station_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fuel_stations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fuel_stations/:fuel_station_id/fuel_movements(.:format)
 * @param {any} fuel_station_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fuel_station_fuel_movements_path = /*#__PURE__*/ __route({"fuel_station_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fuel_stations"],[2,[7,"/"],[2,[3,"fuel_station_id"],[2,[7,"/"],[2,[6,"fuel_movements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fuel_stations/:fuel_station_id/fuel_pumps/:id(.:format)
 * @param {any} fuel_station_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fuel_station_fuel_pump_path = /*#__PURE__*/ __route({"fuel_station_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fuel_stations"],[2,[7,"/"],[2,[3,"fuel_station_id"],[2,[7,"/"],[2,[6,"fuel_pumps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fuel_stations/:fuel_station_id/fuel_pumps(.:format)
 * @param {any} fuel_station_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fuel_station_fuel_pumps_path = /*#__PURE__*/ __route({"fuel_station_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fuel_stations"],[2,[7,"/"],[2,[3,"fuel_station_id"],[2,[7,"/"],[2,[6,"fuel_pumps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fuel_stations/:fuel_station_id/fuel_tanks/:id(.:format)
 * @param {any} fuel_station_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fuel_station_fuel_tank_path = /*#__PURE__*/ __route({"fuel_station_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fuel_stations"],[2,[7,"/"],[2,[3,"fuel_station_id"],[2,[7,"/"],[2,[6,"fuel_tanks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fuel_stations/:fuel_station_id/fuel_tanks(.:format)
 * @param {any} fuel_station_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fuel_station_fuel_tanks_path = /*#__PURE__*/ __route({"fuel_station_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fuel_stations"],[2,[7,"/"],[2,[3,"fuel_station_id"],[2,[7,"/"],[2,[6,"fuel_tanks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fuel_stations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fuel_stations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fuel_stations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /fuel_tanks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fuel_tank_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fuel_tanks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fuel_tanks/:fuel_tank_id/fuel_movements(.:format)
 * @param {any} fuel_tank_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fuel_tank_fuel_movements_path = /*#__PURE__*/ __route({"fuel_tank_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fuel_tanks"],[2,[7,"/"],[2,[3,"fuel_tank_id"],[2,[7,"/"],[2,[6,"fuel_movements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fuel_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fuel_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fuel_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fuel_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fuel_types_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fuel_types"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json/field_inventory_history_items/future(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const future_json_field_inventory_history_items_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"field_inventory_history_items"],[2,[7,"/"],[2,[6,"future"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /weather_stations/general_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const general_report_weather_stations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"weather_stations"],[2,[7,"/"],[2,[6,"general_report"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /geo_raster_image_generate_signed_url(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const geo_raster_image_generate_signed_url_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"geo_raster_image_generate_signed_url"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /geocoder/geocode(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const geocoder_geocode_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"geocoder"],[2,[7,"/"],[2,[6,"geocode"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/agro_operations/get_work_type_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_work_type_groups_json_agro_operations_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[6,"get_work_type_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /google_cloud_signed_urls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const google_cloud_signed_urls_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"google_cloud_signed_urls"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /gps_loggers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gps_logger_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gps_loggers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/agro_operations/:id/gps_track(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gps_track_field_agro_operation_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"gps_track"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /grain_elevators/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grain_elevator_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"grain_elevators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /grain_elevators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grain_elevators_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"grain_elevators"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /growth_regulator_recommendations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const growth_regulator_recommendations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"growth_regulator_recommendations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /reports/indicators_of_harvest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const harvest_indicators_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"indicators_of_harvest"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/harvest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const harvest_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"harvest"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /harvest_trackings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const harvest_tracking_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"harvest_trackings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /harvest_trackings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const harvest_trackings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"harvest_trackings"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /harvest_transportations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const harvest_transportation_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"harvest_transportations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /harvest_transportations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const harvest_transportations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"harvest_transportations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /machines/reports/hourly_work_in_machine_task_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hourly_work_in_machine_task_report_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"hourly_work_in_machine_task_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/land_parcels/ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ids_json_land_parcels_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"land_parcels"],[2,[7,"/"],[2,[6,"ids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /implements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implement_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"implements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /implements/:implement_id/maintenance_records/:id(.:format)
 * @param {any} implement_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implement_maintenance_record_path = /*#__PURE__*/ __route({"implement_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"implements"],[2,[7,"/"],[2,[3,"implement_id"],[2,[7,"/"],[2,[6,"maintenance_records"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /implements/:implement_id/maintenance_records(.:format)
 * @param {any} implement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implement_maintenance_records_path = /*#__PURE__*/ __route({"implement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"implements"],[2,[7,"/"],[2,[3,"implement_id"],[2,[7,"/"],[2,[6,"maintenance_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/machine_tasks/implements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const implements_json_machine_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"machine_tasks"],[2,[7,"/"],[2,[6,"implements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /import_base_crops(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_base_crops_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"import_base_crops"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /import_chemical_products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_chemical_products_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"import_chemical_products"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /import_chemical_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_chemical_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"import_chemical_templates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /lpis_crop_rotation_imports/import_crop_rotation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_crop_rotation_lpis_crop_rotation_imports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lpis_crop_rotation_imports"],[2,[7,"/"],[2,[6,"import_crop_rotation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /import_crop_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_crop_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"import_crop_templates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /import_fertilizer_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_fertilizer_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"import_fertilizer_templates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /import_seed_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_seed_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"import_seed_templates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/manual_work_plan_items/:id/inline_update(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inline_update_field_manual_work_plan_item_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"manual_work_plan_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"inline_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instant_notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instant_notifications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"instant_notifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /integrated_crop_production_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrated_crop_production_report_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"integrated_crop_production_report"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /integrations/:category/:integration(.:format)
 * @param {any} category
 * @param {any} integration
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integration_path = /*#__PURE__*/ __route({"category":{"r":true},"integration":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"category"],[2,[7,"/"],[2,[3,"integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /inventory_tracking(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inventory_tracking_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"inventory_tracking"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /field_shapes_downloads/download_isoxml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const isoxml_field_shapes_downloads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"field_shapes_downloads"],[2,[7,"/"],[2,[6,"download_isoxml"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /issue_wh_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const issue_wh_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"issue_wh_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /issue_wh_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const issue_wh_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"issue_wh_documents"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json/admin_users/search_available_admin_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_admin_users_search_available_admin_users_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"admin_users"],[2,[7,"/"],[2,[6,"search_available_admin_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/ai_boosting_api_syncs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_ai_boosting_api_syncs_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"ai_boosting_api_syncs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/ai_user_growth_stages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_ai_user_growth_stages_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"ai_user_growth_stages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/billing_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_billing_details_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"billing_details"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_comment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_comments_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/compant_area_statistics/:date(.:format)
 * @param {any} date
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_company_area_statistics_path = /*#__PURE__*/ __route({"date":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"compant_area_statistics"],[2,[7,"/"],[2,[3,"date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/company_versions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_company_versions_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"company_versions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/company_year_statistics/:year(.:format)
 * @param {any} year
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_company_year_statistics_path = /*#__PURE__*/ __route({"year":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"company_year_statistics"],[2,[7,"/"],[2,[3,"year"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/consumption_targets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_consumption_targets_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"consumption_targets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/counterparties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_counterparties_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"counterparties"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/crop_rotation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_crop_rotation_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"crop_rotation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/field_group_extents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_field_group_extent_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"field_group_extents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/fields/:field_id/potato_treatments(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_field_potato_treatments_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"potato_treatments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /json/field_shapes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_field_shapes_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"field_shapes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /field_shapes_downloads/download_json(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_field_shapes_downloads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"field_shapes_downloads"],[2,[7,"/"],[2,[6,"download_json"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/filtered_cadastral_land_parcels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_filtered_cadastral_land_parcels_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"filtered_cadastral_land_parcels"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/filtered_land_parcel_owners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_filtered_land_parcel_owners_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"filtered_land_parcel_owners"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/growth_regulator_profiles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_growth_regulator_profiles_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"growth_regulator_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/growth_scales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_growth_scales_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"growth_scales"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/insects_monitoring(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_insects_monitoring_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"insects_monitoring"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/land_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_land_documents_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"land_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /land_parcel_shapes_downloads/download_json(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_land_parcel_shapes_downloads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"land_parcel_shapes_downloads"],[2,[7,"/"],[2,[6,"download_json"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/land_parcels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_land_parcels_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"land_parcels"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/land_parcels/filtered_field_shapes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_land_parcels_filtered_field_shapes_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"land_parcels"],[2,[7,"/"],[2,[6,"filtered_field_shapes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/land_parcels/:land_parcel_id/intersected_field_shapes(.:format)
 * @param {any} land_parcel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_land_parcels_intersected_field_shapes_path = /*#__PURE__*/ __route({"land_parcel_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"land_parcels"],[2,[7,"/"],[2,[3,"land_parcel_id"],[2,[7,"/"],[2,[6,"intersected_field_shapes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /json/machine_tracks/accept_drone_flight_tracks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_machine_tracks_accept_drone_flight_tracks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"machine_tracks"],[2,[7,"/"],[2,[6,"accept_drone_flight_tracks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/machine_tracks/machine_movements_geojson(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_machine_tracks_machine_movements_geojson_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"machine_tracks"],[2,[7,"/"],[2,[6,"machine_movements_geojson"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/machine_tracks/machine_tasks_tracks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_machine_tracks_machine_tasks_tracks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"machine_tracks"],[2,[7,"/"],[2,[6,"machine_tasks_tracks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/ndvi_histogram_of_fields_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_ndvi_histogram_of_fields_data_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"ndvi_histogram_of_fields_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/ndvi_variability(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_ndvi_variability_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"ndvi_variability"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/por_import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_por_import_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"por_import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/predecessor_matrices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_predecessor_matrices_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"predecessor_matrices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/predecessor_matrices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_predecessor_matrix_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"predecessor_matrices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/price_list_scopes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_price_list_scopes_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"price_list_scopes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/product_plus_store_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_product_plus_store_requests_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"product_plus_store_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/products_plus_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_products_plus_report_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"products_plus_report"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/regional_backgrounds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_regional_backgrounds_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"regional_backgrounds"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machines/reports/machine_downtimes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_report_downtimes_machines_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"machine_downtimes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/sdhi_fungicides/custom_measurements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_sdhi_fungicides_custom_measurements_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"sdhi_fungicides"],[2,[7,"/"],[2,[6,"custom_measurements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/sdhi_fungicides/field_moisture(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_sdhi_fungicides_field_moisture_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"sdhi_fungicides"],[2,[7,"/"],[2,[6,"field_moisture"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/sdhi_fungicides/moisture_charts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_sdhi_fungicides_moisture_charts_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"sdhi_fungicides"],[2,[7,"/"],[2,[6,"moisture_charts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/sdhi_fungicides/preference(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_sdhi_fungicides_preference_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"sdhi_fungicides"],[2,[7,"/"],[2,[6,"preference"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/fields/seeding_rates_optimizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_seeding_rates_optimizations_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[6,"seeding_rates_optimizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/tech_fluid_consumption_norms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_tech_fluid_consumption_norms_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"tech_fluid_consumption_norms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/users/search_available_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_users_search_available_users_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"search_available_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/wh_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_wh_documents_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"wh_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/wh_items/:wh_item_id/skus/:id(.:format)
 * @param {any} wh_item_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_wh_item_sku_path = /*#__PURE__*/ __route({"wh_item_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"wh_items"],[2,[7,"/"],[2,[3,"wh_item_id"],[2,[7,"/"],[2,[6,"skus"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /json/wh_items/:wh_item_id/skus(.:format)
 * @param {any} wh_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_wh_item_skus_path = /*#__PURE__*/ __route({"wh_item_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"wh_items"],[2,[7,"/"],[2,[3,"wh_item_id"],[2,[7,"/"],[2,[6,"skus"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /field_shapes_downloads/download_kml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kml_field_shapes_downloads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"field_shapes_downloads"],[2,[7,"/"],[2,[6,"download_kml"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /land_parcel_shapes_downloads/download_kml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kml_land_parcel_shapes_downloads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"land_parcel_shapes_downloads"],[2,[7,"/"],[2,[6,"download_kml"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /land_declarations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const land_declaration_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"land_declarations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /land_declarations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const land_declarations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"land_declarations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /land_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const land_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"land_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /land_document_downloads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const land_document_downloads_path = /*#__PURE__*/ __route({"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"land_document_downloads"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /land_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const land_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"land_documents"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /land_intersection_map_cache_fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const land_intersection_map_cache_fields_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"land_intersection_map_cache_fields"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /land_intersection_map_cache_land_parcels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const land_intersection_map_cache_land_parcels_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"land_intersection_map_cache_land_parcels"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /land_intersection_map_fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const land_intersection_map_fields_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"land_intersection_map_fields"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /land_intersection_map_land_parcels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const land_intersection_map_land_parcels_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"land_intersection_map_land_parcels"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /land_intersection_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const land_intersection_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"land_intersection_reports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /land_parcels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const land_parcel_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"land_parcels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /land_parcel_data_loads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const land_parcel_data_loads_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"land_parcel_data_loads"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /land_parcel_group_downloads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const land_parcel_group_downloads_path = /*#__PURE__*/ __route({"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"land_parcel_group_downloads"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json/field_shapes/:id/land_parcel_intersections(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const land_parcel_intersections_json_field_shape_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"field_shapes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"land_parcel_intersections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /json/field_shapes/:id/land_parcel_mappings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const land_parcel_mappings_json_field_shape_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"field_shapes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"land_parcel_mappings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /json/field_shapes/land_parcel_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const land_parcel_options_json_field_shapes_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"field_shapes"],[2,[7,"/"],[2,[6,"land_parcel_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /land_parcels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const land_parcels_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"land_parcels"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /land_parcel_maps/land_parcels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const land_parcels_land_parcel_maps_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"land_parcel_maps"],[2,[7,"/"],[2,[6,"land_parcels"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /external_service_settings/fields/:integration_type(.:format)
 * @param {any} integration_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const list_external_service_settings_fields_path = /*#__PURE__*/ __route({"integration_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_service_settings"],[2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"integration_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /transfer_wh_documents/load_approved_transfer_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_approved_transfer_requests_transfer_wh_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"transfer_wh_documents"],[2,[7,"/"],[2,[6,"load_approved_transfer_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /issue_wh_documents/load_field_agro_operation_mtfmi(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_field_agro_operation_mtfmi_issue_wh_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"issue_wh_documents"],[2,[7,"/"],[2,[6,"load_field_agro_operation_mtfmi"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /wh_inventory_transfer_requests/load_field_and_agro_operation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_field_and_agro_operation_wh_inventory_transfer_requests_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"wh_inventory_transfer_requests"],[2,[7,"/"],[2,[6,"load_field_and_agro_operation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /vendor_invoices/load_related_document_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_related_document_options_vendor_invoices_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"vendor_invoices"],[2,[7,"/"],[2,[6,"load_related_document_options"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /vendor_invoices/load_related_object_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_related_object_options_vendor_invoices_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"vendor_invoices"],[2,[7,"/"],[2,[6,"load_related_object_options"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /transfer_wh_documents/load_remaining_by_sku(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_remaining_by_sku_transfer_wh_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"transfer_wh_documents"],[2,[7,"/"],[2,[6,"load_remaining_by_sku"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /local_communities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const local_communities_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"local_communities"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /local_communities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const local_community_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"local_communities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /local_community_form/fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const local_community_form_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"local_community_form"],[2,[7,"/"],[2,[6,"fields"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /login/interoperability-status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_interoperability_status_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"login"],[2,[7,"/"],[2,[6,"interoperability-status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /login/oauth2/authorize/:provider(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_single_sign_on_authorize_path = /*#__PURE__*/ __route({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"login"],[2,[7,"/"],[2,[6,"oauth2"],[2,[7,"/"],[2,[6,"authorize"],[2,[7,"/"],[2,[3,"provider"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /logistics/waybills/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logistics_waybill_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"logistics"],[2,[7,"/"],[2,[6,"waybills"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /logistics/waybills(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logistics_waybills_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"logistics"],[2,[7,"/"],[2,[6,"waybills"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machines/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/alerts/:id(.:format)
 * @param {any} machine_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_alert_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"alerts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machine_downtime_exclusions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_downtime_exclusion_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machine_downtime_exclusions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machine_downtime_exclusions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_downtime_exclusions_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machine_downtime_exclusions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /machine_downtime_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_downtime_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machine_downtime_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machine_downtime_type_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_downtime_type_group_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machine_downtime_type_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machine_downtime_type_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_downtime_type_groups_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machine_downtime_type_groups"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /machine_downtime_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_downtime_types_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machine_downtime_types"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/fuel_movements(.:format)
 * @param {any} machine_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_fuel_movements_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"fuel_movements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/fuel_pumps/:id(.:format)
 * @param {any} machine_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_fuel_pump_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"fuel_pumps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/fuel_pumps(.:format)
 * @param {any} machine_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_fuel_pumps_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"fuel_pumps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/fuel_tanks/:id(.:format)
 * @param {any} machine_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_fuel_tank_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"fuel_tanks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/fuel_tanks(.:format)
 * @param {any} machine_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_fuel_tanks_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"fuel_tanks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/harvest_weighings/:id(.:format)
 * @param {any} machine_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_harvest_weighing_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"harvest_weighings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/implements_hourly_work_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_implements_hourly_work_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"implements_hourly_work_report"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/machine_downtimes/:id(.:format)
 * @param {any} machine_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_machine_downtime_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"machine_downtimes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/machine_downtimes(.:format)
 * @param {any} machine_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_machine_downtimes_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"machine_downtimes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/tasks/:id(.:format)
 * @param {any} machine_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_machine_task_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/tasks/:machine_task_id/fields_work_results/:id(.:format)
 * @param {any} machine_id
 * @param {any} machine_task_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_machine_task_machine_task_field_mapping_item_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"machine_task_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"machine_task_id"],[2,[7,"/"],[2,[6,"fields_work_results"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/tasks(.:format)
 * @param {any} machine_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_machine_tasks_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/maintenance_records/:id(.:format)
 * @param {any} machine_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_maintenance_record_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"maintenance_records"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/maintenance_records(.:format)
 * @param {any} machine_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_maintenance_records_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"maintenance_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/odometer_states(.:format)
 * @param {any} machine_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_odometer_states_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"odometer_states"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machine_operators/statistics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_operator_statistics_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machine_operators"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machine_operators/tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_operator_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machine_operators"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/rent_items(.:format)
 * @param {any} machine_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_rent_items_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"rent_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machine_tasks/create_without_machine(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_tasks_create_without_machine_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machine_tasks"],[2,[7,"/"],[2,[6,"create_without_machine"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machine_tasks/duplicate_from_existing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_tasks_duplicate_from_existing_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machine_tasks"],[2,[7,"/"],[2,[6,"duplicate_from_existing"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machine_tasks_index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_tasks_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machine_tasks_index"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /machines/machine_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_tasks_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"machine_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machine_tasks/new_without_machine(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_tasks_new_without_machine_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machine_tasks"],[2,[7,"/"],[2,[6,"new_without_machine"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/agri_work_plans/machine_work_plan_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_work_plan_data_json_agri_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"machine_work_plan_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machine_work_plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machine_work_plans_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machine_work_plans"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /machinery_manufacturers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machinery_manufacturer_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machinery_manufacturers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machinery_manufacturers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machinery_manufacturers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machinery_manufacturers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /machinery_models/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machinery_model_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machinery_models"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machinery_models(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machinery_models_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machinery_models"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json/machine_reports/machines_filter_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machines_filter_data_json_machine_reports_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"machine_reports"],[2,[7,"/"],[2,[6,"machines_filter_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/reports/machines_stops_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const machines_stops_report_machines_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"machines_stops_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /maintenance_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maintenance_dashboard_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"maintenance_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /maintenance_plans/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maintenance_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"maintenance_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /maintenance_plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maintenance_plans_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"maintenance_plans"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /maintenance_records/:id/documents(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maintenance_records_documents_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"maintenance_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/machine_tasks/maintenance_records(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maintenance_records_json_machine_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"machine_tasks"],[2,[7,"/"],[2,[6,"maintenance_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /maintenance_records/:id/maintenance_record_rows/:row_id/photos/:photo_id(.:format)
 * @param {any} id
 * @param {any} row_id
 * @param {any} photo_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maintenance_records_row_photo_path = /*#__PURE__*/ __route({"id":{"r":true},"row_id":{"r":true},"photo_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"maintenance_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"maintenance_record_rows"],[2,[7,"/"],[2,[3,"row_id"],[2,[7,"/"],[2,[6,"photos"],[2,[7,"/"],[2,[3,"photo_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /maintenance_records/:id/maintenance_record_rows/:row_id/photos(.:format)
 * @param {any} id
 * @param {any} row_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maintenance_records_row_photos_path = /*#__PURE__*/ __route({"id":{"r":true},"row_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"maintenance_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"maintenance_record_rows"],[2,[7,"/"],[2,[3,"row_id"],[2,[7,"/"],[2,[6,"photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /maintenance_warehouse_stocks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maintenance_warehouse_stocks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"maintenance_warehouse_stocks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /maize_hybrid_harvests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maize_hybrid_harvests_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"maize_hybrid_harvests"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /manual_tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manual_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manual_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /manual_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manual_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"manual_tasks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json/manual_tasks/manual_tasks_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manual_tasks_data_json_manual_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"manual_tasks"],[2,[7,"/"],[2,[6,"manual_tasks_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /manual_work_plans/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manual_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manual_work_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/manual_work_plans/manual_work_plan_show_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manual_work_plan_show_data_json_manual_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"manual_work_plans"],[2,[7,"/"],[2,[6,"manual_work_plan_show_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /manual_work_plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manual_work_plans_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"manual_work_plans"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json/manual_work_plans/manual_work_plans_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manual_work_plans_data_json_manual_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"manual_work_plans"],[2,[7,"/"],[2,[6,"manual_work_plans_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/manual_tasks/manual_work_plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manual_work_plans_json_manual_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"manual_tasks"],[2,[7,"/"],[2,[6,"manual_work_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/machineries/manufacturers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manufacturers_json_machineries_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"machineries"],[2,[7,"/"],[2,[6,"manufacturers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/agri_work_plans/map_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const map_data_json_agri_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"map_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/field_groups/:id/map_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const map_data_json_field_group_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"field_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"map_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /json/manual_work_plans/map_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const map_data_json_manual_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"manual_work_plans"],[2,[7,"/"],[2,[6,"map_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/machine_downtimes/map(.:format)
 * @param {any} machine_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const map_machine_machine_downtimes_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"machine_downtimes"],[2,[7,"/"],[2,[6,"map"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pivots/map(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const map_pivots_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pivots"],[2,[7,"/"],[2,[6,"map"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /map_soil_tests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const map_soil_tests_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"map_soil_tests"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /map_soil_tests/samples(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const map_soil_tests_samples_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"map_soil_tests"],[2,[7,"/"],[2,[6,"samples"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /maps_for_prints(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maps_for_prints_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"maps_for_prints"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /instant_notifications/mark_all_as_read(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_all_as_read_instant_notifications_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"instant_notifications"],[2,[7,"/"],[2,[6,"mark_all_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /instant_notifications/:id/mark_as_read(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_read_instant_notification_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instant_notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /market_view/widget(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const market_view_widget_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"market_view"],[2,[7,"/"],[2,[6,"widget"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:applicable_type/mass_changes_ami/:id(.:format)
 * @param {any} applicable_type
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mass_changes_ami_path = /*#__PURE__*/ __route({"applicable_type":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"applicable_type"],[2,[7,"/"],[2,[6,"mass_changes_ami"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /direction_lines/mass_request(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mass_request_direction_lines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"direction_lines"],[2,[7,"/"],[2,[6,"mass_request"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mobile_weather_stations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mobile_weather_station_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile_weather_stations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/machineries/models(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const models_json_machineries_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"machineries"],[2,[7,"/"],[2,[6,"models"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /monitoring_center(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_center_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"monitoring_center"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /monitoring_center/fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_center_fields_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"monitoring_center"],[2,[7,"/"],[2,[6,"fields"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /monitoring_center/weather(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_center_weather_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"monitoring_center"],[2,[7,"/"],[2,[6,"weather"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machines/monitoring_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_data_machines_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"monitoring_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machines/monitoring(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitoring_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"monitoring"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/soil_test_tasks/multiple_duplicate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multiple_duplicate_report_soil_test_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"soil_test_tasks"],[2,[7,"/"],[2,[6,"multiple_duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/soil_test_tasks/multiple_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multiple_export_report_soil_test_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"soil_test_tasks"],[2,[7,"/"],[2,[6,"multiple_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/multiple_write_off_act(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multiple_write_off_act_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"multiple_write_off_act"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /my_john_deere/organizations/:id/machines(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_john_deere_organization_machines_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"my_john_deere"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"machines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ndvi_grid_raw(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ndvi_grid_raw_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"ndvi_grid_raw"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json/satellite_images/ndvi_images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ndvi_images_json_satellite_images_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"satellite_images"],[2,[7,"/"],[2,[6,"ndvi_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agri_work_plans/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_agri_work_plan_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agri_work_plans/:agri_work_plan_id/machine_work_plans/new(.:format)
 * @param {any} agri_work_plan_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_agri_work_plan_machine_work_plan_path = /*#__PURE__*/ __route({"agri_work_plan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"agri_work_plan_id"],[2,[7,"/"],[2,[6,"machine_work_plans"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agri_works_manager/new_agro_operations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_agro_operations_agri_works_manager_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"agri_works_manager"],[2,[7,"/"],[2,[6,"new_agro_operations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /agri_works_manager/new_agro_operations_fields_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_agro_operations_fields_data_agri_works_manager_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"agri_works_manager"],[2,[7,"/"],[2,[6,"new_agro_operations_fields_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /new_agro_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_agro_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"new_agro_tasks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /automatic_alerts/new/:automatic_alert_type/:automatic_alert_subtype(.:format)
 * @param {any} automatic_alert_type
 * @param {any} automatic_alert_subtype
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_automatic_alerts_path = /*#__PURE__*/ __route({"automatic_alert_type":{"r":true},"automatic_alert_subtype":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"automatic_alerts"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"automatic_alert_type"],[2,[7,"/"],[2,[3,"automatic_alert_subtype"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /automatic_notifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_automatic_notification_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"automatic_notifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /automatic_scouting_tasks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_automatic_scouting_task_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"automatic_scouting_tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /new_awp_design/agri_work_plans/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_awp_design_agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_awp_design"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /new_awp_design/agri_work_plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_awp_design_agri_work_plans_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"new_awp_design"],[2,[7,"/"],[2,[6,"agri_work_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billing_details/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_billing_detail_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"billing_details"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /chemicals/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_chemical_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"chemicals"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company/benza_sync_settings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_company_benza_sync_setting_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"benza_sync_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/identity_providers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_company_identity_provider_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"identity_providers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/okko_sync_settings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_company_okko_sync_setting_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"okko_sync_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/webdispecink_sync_settings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_company_webdispecink_sync_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"webdispecink_sync_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/wog_sync_settings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_company_wog_sync_setting_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"wog_sync_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /counterparties/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_counterparty_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"counterparties"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /crops/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_crop_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"crops"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fertilizers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_fertilizer_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fertilizers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fields/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_field_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/agro_operations/new(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_field_agro_operation_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/agro_operations/:agro_operation_id/field_work_results/new(.:format)
 * @param {any} field_id
 * @param {any} agro_operation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_field_agro_operation_field_work_result_path = /*#__PURE__*/ __route({"field_id":{"r":true},"agro_operation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[3,"agro_operation_id"],[2,[7,"/"],[2,[6,"field_work_results"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/scout_reports/new(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_field_field_scout_report_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"scout_reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/leaf_tests/new(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_field_leaf_test_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"leaf_tests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/manual_tasks/new(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_field_manual_task_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"manual_tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/productivity_images/new(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_field_productivity_image_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"productivity_images"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/scouting_tasks/new(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_field_scouting_task_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"scouting_tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_tests/new(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_field_soil_test_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_tests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_test_tasks/new(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_field_soil_test_task_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_test_tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_tests/uploads/new(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_field_soil_test_upload_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_tests"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_texture_maps/new(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_field_soil_texture_map_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_texture_maps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/vra_multilayers/new(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_field_vra_multilayer_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"vra_multilayers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/yield_maps/new(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_field_yield_map_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"yield_maps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /field_scout_report_photos_bunch_uploading(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_fsr_bunch_upload_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"field_scout_report_photos_bunch_uploading"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /fuel_inventory_documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_fuel_inventory_document_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fuel_inventory_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fuel_stations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_fuel_station_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fuel_stations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fuel_stations/:fuel_station_id/fuel_tanks/new(.:format)
 * @param {any} fuel_station_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_fuel_station_fuel_tank_path = /*#__PURE__*/ __route({"fuel_station_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fuel_stations"],[2,[7,"/"],[2,[3,"fuel_station_id"],[2,[7,"/"],[2,[6,"fuel_tanks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fuel_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_fuel_type_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"fuel_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /growth_scales/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_growth_scale_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"growth_scales"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /issue_wh_documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_issue_wh_document_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"issue_wh_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /land_documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_land_document_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"land_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /land_parcels/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_land_parcel_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"land_parcels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/alerts/new(.:format)
 * @param {any} machine_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_machine_alert_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"alerts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/fuel_tanks/new(.:format)
 * @param {any} machine_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_machine_fuel_tank_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"fuel_tanks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/tasks/new(.:format)
 * @param {any} machine_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_machine_machine_task_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machinery_manufacturers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_machinery_manufacturer_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machinery_manufacturers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machinery_models/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_machinery_model_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machinery_models"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /manual_tasks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_manual_task_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"manual_tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /manual_work_plans/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_manual_work_plan_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"manual_work_plans"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /map_layers/new/:layer_type(.:format)
 * @param {any} layer_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_map_layers_path = /*#__PURE__*/ __route({"layer_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"map_layers"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"layer_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /new_awp_design/agri_work_plans/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_new_awp_design_agri_work_plan_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"new_awp_design"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pivots/:pivot_id/field_mappings/new(.:format)
 * @param {any} pivot_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_pivot_pivot_field_mapping_path = /*#__PURE__*/ __route({"pivot_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pivots"],[2,[7,"/"],[2,[3,"pivot_id"],[2,[7,"/"],[2,[6,"field_mappings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /plant_threats/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_plant_threat_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"plant_threats"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /plots/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_plot_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"plots"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /receipt_wh_documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_receipt_wh_document_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"receipt_wh_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /registered_fields/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_registered_field_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"registered_fields"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /registered_fields/:registered_field_id/shapes/new(.:format)
 * @param {any} registered_field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_registered_field_registered_field_shape_path = /*#__PURE__*/ __route({"registered_field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registered_fields"],[2,[7,"/"],[2,[3,"registered_field_id"],[2,[7,"/"],[2,[6,"shapes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reglons/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_reglon_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reglons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scout_report_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_scout_report_template_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"scout_report_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scouting_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_scouting_type_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"scouting_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /seeds/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_seed_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"seeds"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shapes_uploads/new/:type(.:format)
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_shapes_uploads_path = /*#__PURE__*/ __route({"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shapes_uploads"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sharing_data_platform/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_sharing_data_platform_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"sharing_data_platform"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /spare_parts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_spare_part_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"spare_parts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machines/new_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_tasks_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"new_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /transfer_wh_documents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_transfer_wh_document_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"transfer_wh_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/legend_scales/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_legend_scale_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"legend_scales"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_roles/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_role_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user_roles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /d/users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"d"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /wh_inventory_transfer_requests/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_wh_inventory_transfer_request_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"wh_inventory_transfer_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /wh_items/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_wh_item_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"wh_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /wh_item_groups/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_wh_item_group_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"wh_item_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /news_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const news_items_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"news_items"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json/agri_work_plans/no_plan_agro_operations_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const no_plan_agro_operations_data_json_agri_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"no_plan_agro_operations_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /new_awp_design/agri_work_plans/:id/nullify_agro_operations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nullify_agro_operations_new_awp_design_agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_awp_design"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"nullify_agro_operations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /new_awp_design/agri_work_plans/:id/nullify_ao_machine_tasks(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nullify_ao_machine_tasks_new_awp_design_agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_awp_design"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"nullify_ao_machine_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agri_works_manager/nullify_machine_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nullify_machine_tasks_agri_works_manager_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"agri_works_manager"],[2,[7,"/"],[2,[6,"nullify_machine_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/nutrition_plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nutrition_plans_report_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"nutrition_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orchard_crops/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orchard_crop_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orchard_crops"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orchards_monitoring_center(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orchards_monitoring_center_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"orchards_monitoring_center"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /orchards_monitoring_center/fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orchards_monitoring_center_fields_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"orchards_monitoring_center"],[2,[7,"/"],[2,[6,"fields"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orchards_monitoring_center/weather(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orchards_monitoring_center_weather_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"orchards_monitoring_center"],[2,[7,"/"],[2,[6,"weather"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/field_inventory_history_items/past(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const past_json_field_inventory_history_items_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"field_inventory_history_items"],[2,[7,"/"],[2,[6,"past"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /instant_notifications/:id/perform_action(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const perform_action_instant_notification_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instant_notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"perform_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /personal_identifiers/:personal_identifier_id/equipment_assignments/:id(.:format)
 * @param {any} personal_identifier_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const personal_identifier_equipment_assignment_path = /*#__PURE__*/ __route({"personal_identifier_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"personal_identifiers"],[2,[7,"/"],[2,[3,"personal_identifier_id"],[2,[7,"/"],[2,[6,"equipment_assignments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /personal_identifiers/:personal_identifier_id/equipment_assignments(.:format)
 * @param {any} personal_identifier_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const personal_identifier_equipment_assignments_path = /*#__PURE__*/ __route({"personal_identifier_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"personal_identifiers"],[2,[7,"/"],[2,[3,"personal_identifier_id"],[2,[7,"/"],[2,[6,"equipment_assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /personal_identifiers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const personal_identifiers_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"personal_identifiers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /pivots/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pivot_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pivots"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pivots/:pivot_id/field_mappings/:id(.:format)
 * @param {any} pivot_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pivot_pivot_field_mapping_path = /*#__PURE__*/ __route({"pivot_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pivots"],[2,[7,"/"],[2,[3,"pivot_id"],[2,[7,"/"],[2,[6,"field_mappings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pivots/:pivot_id/field_mappings(.:format)
 * @param {any} pivot_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pivot_pivot_field_mappings_path = /*#__PURE__*/ __route({"pivot_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pivots"],[2,[7,"/"],[2,[3,"pivot_id"],[2,[7,"/"],[2,[6,"field_mappings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pivots(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pivots_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pivots"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /plant_threats/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plant_threat_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"plant_threats"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /plant_threat_scores(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plant_threat_scores_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"plant_threat_scores"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /platform(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const platform_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"platform"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /plots/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plot_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"plots"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /plots(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plots_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"plots"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /plots_of_field(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plots_of_field_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"plots_of_field"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /potato_treatments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const potato_treatments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"potato_treatments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /price_lists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const price_list_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"price_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /price_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const price_lists_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"price_lists"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /weather_stations/private_stations_hourly_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_stations_hourly_report_weather_stations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"weather_stations"],[2,[7,"/"],[2,[6,"private_stations_hourly_report"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /weather_stations/private_stations_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const private_stations_report_weather_stations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"weather_stations"],[2,[7,"/"],[2,[6,"private_stations_report"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /production_cycles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const production_cycle_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"production_cycles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /production_cycles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const production_cycles_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"production_cycles"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /protected_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const protected_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"protected_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /protected_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const protected_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"protected_documents"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json/manual_tasks/quarters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quarters_json_manual_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"manual_tasks"],[2,[7,"/"],[2,[6,"quarters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /recalculate_data_source_parameter_history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recalculate_data_source_parameter_history_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"recalculate_data_source_parameter_history"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /receipt_wh_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receipt_wh_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"receipt_wh_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /receipt_wh_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receipt_wh_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"receipt_wh_documents"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /registered_fields/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registered_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registered_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /registered_fields/:registered_field_id/agro_operations(.:format)
 * @param {any} registered_field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registered_field_agro_operations_path = /*#__PURE__*/ __route({"registered_field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registered_fields"],[2,[7,"/"],[2,[3,"registered_field_id"],[2,[7,"/"],[2,[6,"agro_operations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /registered_fields/:registered_field_id/crops(.:format)
 * @param {any} registered_field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registered_field_registered_field_crops_path = /*#__PURE__*/ __route({"registered_field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registered_fields"],[2,[7,"/"],[2,[3,"registered_field_id"],[2,[7,"/"],[2,[6,"crops"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /registered_fields/:registered_field_id/shapes/:id(.:format)
 * @param {any} registered_field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registered_field_registered_field_shape_path = /*#__PURE__*/ __route({"registered_field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registered_fields"],[2,[7,"/"],[2,[3,"registered_field_id"],[2,[7,"/"],[2,[6,"shapes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /registered_fields/:registered_field_id/shapes(.:format)
 * @param {any} registered_field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registered_field_registered_field_shapes_path = /*#__PURE__*/ __route({"registered_field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"registered_fields"],[2,[7,"/"],[2,[3,"registered_field_id"],[2,[7,"/"],[2,[6,"shapes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /registered_fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registered_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"registered_fields"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /d/users/sign_up/map_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registration_map_data_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"d"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[2,[7,"/"],[2,[6,"map_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reglons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reglons_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reglons"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json/history_items/:id/related_agro_operations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const related_agro_operations_json_history_item_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"history_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"related_agro_operations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tickets/:id/related_attachments(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const related_attachments_ticket_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"related_attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tickets/:id/related_comments(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const related_comments_ticket_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"related_comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/machine_tasks/related_machine_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const related_machine_tasks_json_machine_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"machine_tasks"],[2,[7,"/"],[2,[6,"related_machine_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /warehouses/related_objects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const related_objects_warehouses_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"warehouses"],[2,[7,"/"],[2,[6,"related_objects"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tickets/:id/related_versions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const related_versions_ticket_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"related_versions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:id/relief_report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relief_report_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"pdf"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relief_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /gps_loggers/:id/remove_history(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_history_gps_logger_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gps_loggers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rent_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rent_request_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rent_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rent_items/:id/rent_requests(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rent_requests_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rent_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rent_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tickets/:id/reopen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopen_ticket_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /report_crop_expenses_analysis(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_crop_expenses_analysis_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"report_crop_expenses_analysis"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json/por_import/report_list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_list_json_por_import_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"por_import"],[2,[7,"/"],[2,[6,"report_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/overgrowth_risk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_overgrowth_risk_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"overgrowth_risk"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/scout_reports/growth_stages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_scout_reports_growth_stages_path = /*#__PURE__*/ __route({"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"scout_reports"],[2,[7,"/"],[2,[6,"growth_stages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/scout_reports/point_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_scout_reports_point_details_path = /*#__PURE__*/ __route({"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"scout_reports"],[2,[7,"/"],[2,[6,"point_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/soil_test_tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_soil_test_task_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"soil_test_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/soil_test_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_soil_test_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"soil_test_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/vegetation/changes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_vegetation_changes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"vegetation"],[2,[7,"/"],[2,[6,"changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/vegetation_variability/changes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_vegetation_variability_changes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"vegetation_variability"],[2,[7,"/"],[2,[6,"changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/vra/tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_vra_task_show_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"vra"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/vra/tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_vra_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"vra"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/agro_operations/application(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_agro_operations_application_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[6,"application"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/agro_operations/consolidated(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_agro_operations_consolidated_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[6,"consolidated"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/reports/asset_checklists/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_asset_checklists_download_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"asset_checklists"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/reports/asset_checklists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_asset_checklists_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"asset_checklists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/reports/daily_work(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_daily_work_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"daily_work"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/reports/fuel_by_periods(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_fuel_by_periods_download_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"fuel_by_periods"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/reports/fuel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_fuel_download_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"fuel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/reports/fuel_movements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_fuel_movement_download_machines_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"fuel_movements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/reports/gps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_gps_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"gps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/reports/hourly_work(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_hourly_work_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"hourly_work"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/reports/implements_perfomance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_implements_perfomance_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"implements_perfomance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/reports/intersections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_intersection_data_machines_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"intersections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/reports/maintenance_detailed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_maintenance_detailed_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"maintenance_detailed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/reports/perfomance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_perfomance_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"perfomance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/scout_reports/consolidated(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_scout_reports_consolidated_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"scout_reports"],[2,[7,"/"],[2,[6,"consolidated"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/reports/weighing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_weighings_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"weighing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/reports/work(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_work_machines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"work"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/application_tasks/resample_grid(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resample_grid_field_application_tasks_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"application_tasks"],[2,[7,"/"],[2,[6,"resample_grid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /gps_logger_mapping_items/:id/resolve_related_data_sources(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_related_data_sources_gps_logger_mapping_item_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gps_logger_mapping_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve_related_data_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /weather_stations/:id/resync_history(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resync_history_weather_station_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"weather_stations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resync_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/manual_tasks/rows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rows_json_manual_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"manual_tasks"],[2,[7,"/"],[2,[6,"rows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:id/satellite_image_farm_management_export(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const satellite_image_farm_management_export_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"csv"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"satellite_image_farm_management_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:id/satellite_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const satellite_image_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"tiff"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"satellite_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:id/satellite_images_report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const satellite_images_report_field_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"pdf"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"satellite_images_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/por_import/save_info_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_info_data_json_por_import_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"por_import"],[2,[7,"/"],[2,[6,"save_info_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/machine_tasks/schedule_auto_machine_task_job(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_auto_machine_task_job_json_machine_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"machine_tasks"],[2,[7,"/"],[2,[6,"schedule_auto_machine_task_job"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /harvest_transportations/schedule_job(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_job_harvest_transportations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"harvest_transportations"],[2,[7,"/"],[2,[6,"schedule_job"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/machine_downtimes/schedule_machine_downtimes_recalc(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_machine_downtimes_recalc_json_machine_downtimes_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"machine_downtimes"],[2,[7,"/"],[2,[6,"schedule_machine_downtimes_recalc"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/benza_sync_settings/:id/schedule_sync(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_sync_company_benza_sync_setting_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"benza_sync_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"schedule_sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/okko_sync_settings/:id/schedule_sync(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_sync_company_okko_sync_setting_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"okko_sync_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"schedule_sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company/orwii_sync_settings/schedule_sync(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_sync_company_orwii_sync_settings_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"orwii_sync_settings"],[2,[7,"/"],[2,[6,"schedule_sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/wog_sync_settings/:id/schedule_sync(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_sync_company_wog_sync_setting_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"wog_sync_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"schedule_sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agri_work_plans/schedule_work_plan_resolver(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_work_plan_resolver_agri_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"schedule_work_plan_resolver"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/machine_tasks/scheduled_machine_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduled_machine_tasks_json_machine_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"machine_tasks"],[2,[7,"/"],[2,[6,"scheduled_machine_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scout_report_measurement_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scout_report_measurement_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scout_report_measurement_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scout_report_measurement_value_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scout_report_measurement_value_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scout_report_measurement_value_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scout_report_measurement_value_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scout_report_measurement_value_types_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"scout_report_measurement_value_types"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /reports/scouting_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scouting_tasks_report_path = /*#__PURE__*/ __route({"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"scouting_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scouting_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scouting_type_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scouting_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scouting_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scouting_types_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"scouting_types"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json/beet_cercospora_forecast/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_json_beet_cercospora_forecast_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"beet_cercospora_forecast"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/detecting_weedy_fields/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_json_detecting_weedy_fields_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"detecting_weedy_fields"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/maize_hybrid_harvest/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_json_maize_hybrid_harvest_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"maize_hybrid_harvest"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/reglons/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_json_reglons_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"reglons"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/sunflower_rust/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_json_sunflower_rust_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"sunflower_rust"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /search_plant_varieties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_plant_varieties_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"search_plant_varieties"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /seasons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const season_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"seasons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /seasons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seasons_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"seasons"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /seeds/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seed_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"seeds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /seeding_rates_optimizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seeding_rates_optimizations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"seeding_rates_optimizations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /seeds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seeds_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"seeds"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /seeds_moisture_tracking(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seeds_moisture_tracking_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"seeds_moisture_tracking"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /select2/fuel_stations/:fuel_station_id/data_source_gps_loggers(.:format)
 * @param {any} fuel_station_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_fuel_station_data_source_gps_loggers_path = /*#__PURE__*/ __route({"fuel_station_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"select2"],[2,[7,"/"],[2,[6,"fuel_stations"],[2,[7,"/"],[2,[3,"fuel_station_id"],[2,[7,"/"],[2,[6,"data_source_gps_loggers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /select2/fuel_stations_with_sensors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_fuel_stations_with_sensors_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"select2"],[2,[7,"/"],[2,[6,"fuel_stations_with_sensors"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /select2/implements/:implement_id/data_source_gps_loggers(.:format)
 * @param {any} implement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_implement_data_source_gps_loggers_path = /*#__PURE__*/ __route({"implement_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"select2"],[2,[7,"/"],[2,[6,"implements"],[2,[7,"/"],[2,[3,"implement_id"],[2,[7,"/"],[2,[6,"data_source_gps_loggers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /select2/implements_with_sensors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_implements_with_sensors_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"select2"],[2,[7,"/"],[2,[6,"implements_with_sensors"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /select2/machines/:machine_id/data_source_gps_loggers(.:format)
 * @param {any} machine_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_machine_data_source_gps_loggers_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"select2"],[2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"data_source_gps_loggers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /select2/machine_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_machine_tasks_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"select2"],[2,[7,"/"],[2,[6,"machine_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /select2/machines_with_sensors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_machines_with_sensors_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"select2"],[2,[7,"/"],[2,[6,"machines_with_sensors"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /select2/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select2_users_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"select2"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /consultation_requests/select_consultants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_consultants_consultation_requests_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"consultation_requests"],[2,[7,"/"],[2,[6,"select_consultants"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cwo_gpt/chat_actions/:id/select(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_cwo_gpt_chat_action_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cwo_gpt"],[2,[7,"/"],[2,[6,"chat_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"select"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /consultation_requests/select_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_options_consultation_requests_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"consultation_requests"],[2,[7,"/"],[2,[6,"select_options"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /world_crops_map/:year/selected_year_data(.:format)
 * @param {any} year
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selected_world_year_data_path = /*#__PURE__*/ __route({"year":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"world_crops_map"],[2,[7,"/"],[2,[3,"year"],[2,[7,"/"],[2,[6,"selected_year_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /country_crops_map/:year/selected_year_data(.:format)
 * @param {any} year
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selected_year_data_path = /*#__PURE__*/ __route({"year":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"country_crops_map"],[2,[7,"/"],[2,[3,"year"],[2,[7,"/"],[2,[6,"selected_year_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/por_import/send_info_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_info_data_json_por_import_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"por_import"],[2,[7,"/"],[2,[6,"send_info_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lpis_boundaries_imports/send_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_info_lpis_boundaries_imports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lpis_boundaries_imports"],[2,[7,"/"],[2,[6,"send_info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lpis_parcela_boundaries_imports/send_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_info_lpis_parcela_boundaries_imports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"lpis_parcela_boundaries_imports"],[2,[7,"/"],[2,[6,"send_info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cwo_gpt/chats/:id/send_message(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_message_cwo_gpt_chat_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cwo_gpt"],[2,[7,"/"],[2,[6,"chats"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/scout_reports/:id/send_pdf_report_to_email(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_pdf_report_to_email_field_field_scout_report_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"scout_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_pdf_report_to_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/sensor_monitoring/:machine_id(.:format)
 * @param {any} machine_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sensor_monitoring_machine_machines_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[6,"sensor_monitoring"],[2,[7,"/"],[2,[3,"machine_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /session_variables/set_active_machine_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_active_machine_groups_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"session_variables"],[2,[7,"/"],[2,[6,"set_active_machine_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/tasks/:id/set_checked_at(.:format)
 * @param {any} machine_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_checked_at_machine_machine_task_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_checked_at"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /session_variables/set_current_groupables(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_current_groupables_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"session_variables"],[2,[7,"/"],[2,[6,"set_current_groupables"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /session_variables/set_current_machine_regions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_current_machine_regions_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"session_variables"],[2,[7,"/"],[2,[6,"set_current_machine_regions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /session_variables/set_current_production_cycles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_current_production_cycles_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"session_variables"],[2,[7,"/"],[2,[6,"set_current_production_cycles"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /session_variables/set_current_year/:year(.:format)
 * @param {any} year
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_current_year_path = /*#__PURE__*/ __route({"year":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"session_variables"],[2,[7,"/"],[2,[6,"set_current_year"],[2,[7,"/"],[2,[3,"year"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /session_variables/set_favourite(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_favourite_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"session_variables"],[2,[7,"/"],[2,[6,"set_favourite"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/tasks/:machine_task_id/fields_work_results/:id/set_in_transit(.:format)
 * @param {any} machine_id
 * @param {any} machine_task_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_in_transit_machine_machine_task_machine_task_field_mapping_item_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"machine_task_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"machine_task_id"],[2,[7,"/"],[2,[6,"fields_work_results"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_in_transit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /json/agri_work_plans/set_new_design(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_new_design_json_agri_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"set_new_design"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/agri_work_plans/set_old_design(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_old_design_json_agri_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"set_old_design"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /session_variables/set_show_additional_machines_tracks/:mode(.:format)
 * @param {any} mode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_show_additional_machines_tracks_path = /*#__PURE__*/ __route({"mode":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"session_variables"],[2,[7,"/"],[2,[6,"set_show_additional_machines_tracks"],[2,[7,"/"],[2,[3,"mode"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /session_variables/set_show_additional_objects/:mode(.:format)
 * @param {any} mode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_show_additional_objects_path = /*#__PURE__*/ __route({"mode":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"session_variables"],[2,[7,"/"],[2,[6,"set_show_additional_objects"],[2,[7,"/"],[2,[3,"mode"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /session_variables/set_show_all_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_show_all_groups_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"session_variables"],[2,[7,"/"],[2,[6,"set_show_all_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/field_shapes/:id/shape(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shape_json_field_shape_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"field_shapes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"shape"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sharing_data_platform/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sharing_data_platform_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sharing_data_platform"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sharing_data_platform(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sharing_data_platform_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"sharing_data_platform"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/agro_operations/:id/show_with_machine_task_data(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_with_machine_task_data_field_agro_operation_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_with_machine_task_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /field_shapes_downloads/download_shp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shp_field_shapes_downloads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"field_shapes_downloads"],[2,[7,"/"],[2,[6,"download_shp"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /land_parcel_shapes_downloads/download_shp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shp_land_parcel_shapes_downloads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"land_parcel_shapes_downloads"],[2,[7,"/"],[2,[6,"download_shp"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/sign_in_methods/:provider_id(.:format)
 * @param {any} id
 * @param {any} provider_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sign_in_method_user_path = /*#__PURE__*/ __route({"id":{"r":true},"provider_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sign_in_methods"],[2,[7,"/"],[2,[3,"provider_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/application_tasks/soil_test_grid(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const soil_test_grid_field_application_tasks_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"application_tasks"],[2,[7,"/"],[2,[6,"soil_test_grid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/vra_multilayers/layer/:type(.:format)
 * @param {any} field_id
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const source_layer_field_vra_multilayers_path = /*#__PURE__*/ __route({"field_id":{"r":true},"type":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"vra_multilayers"],[2,[7,"/"],[2,[6,"layer"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/vra_multitask_wizard/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sources_fields_vra_multitask_wizard_index_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[6,"vra_multitask_wizard"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spare_parts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spare_part_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spare_parts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /spare_parts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spare_parts_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"spare_parts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /pivots/states(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const states_pivots_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pivots"],[2,[7,"/"],[2,[6,"states"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /external_service_settings/fields/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const status_external_service_settings_fields_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"external_service_settings"],[2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/nutrition_plans/:id/status(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const status_field_nutrition_plan_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"nutrition_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /asset_checklist_templates/suitable_for_asset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suitable_for_asset_asset_checklist_templates_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"asset_checklist_templates"],[2,[7,"/"],[2,[6,"suitable_for_asset"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sunflower_rust(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sunflower_rust_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"sunflower_rust"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /manual_tasks/supervisor_report_to_excel_range(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const supervisor_report_to_excel_range_manual_tasks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"manual_tasks"],[2,[7,"/"],[2,[6,"supervisor_report_to_excel_range"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /supplier_stage_balances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const supplier_stage_balances_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"supplier_stage_balances"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /memberships/switch_company(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switch_company_memberships_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[6,"switch_company"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/agri_work_plans/sync_fields_modal_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_fields_modal_data_json_agri_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"sync_fields_modal_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/agri_work_plans/sync_fields_to_machine_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_fields_to_machine_tasks_json_agri_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"sync_fields_to_machine_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /json/agri_work_plans/:id/tank_calculation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tank_calculation_json_agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tank_calculation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /target_ndvi_monitoring(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const target_ndvi_monitoring_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"target_ndvi_monitoring"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tech_fluid_consumption_norms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tech_fluid_consumption_norm_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tech_fluid_consumption_norms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tech_fluid_consumption_norms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tech_fluid_consumption_norms_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tech_fluid_consumption_norms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tickets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ticket_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ticket_comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ticket_comment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ticket_comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ticket_comment_images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ticket_comment_images_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"ticket_comment_images"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ticket_comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ticket_comments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"ticket_comments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tickets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tickets_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tickets"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /personal_identifiers/:id/toggle_archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_archive_personal_identifier_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"personal_identifiers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /field_groups/top_menu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const top_menu_field_groups_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"field_groups"],[2,[7,"/"],[2,[6,"top_menu"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /machine_regions/top_menu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const top_menu_machine_regions_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"machine_regions"],[2,[7,"/"],[2,[6,"top_menu"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json/field_shapes/:id/tracks(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tracks_json_field_shape_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"field_shapes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tracks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /transfer_wh_documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transfer_wh_document_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"transfer_wh_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /transfer_wh_documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transfer_wh_documents_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"transfer_wh_documents"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /trap_view_devices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trap_view_device_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trap_view_devices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /trap_view_device_events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trap_view_device_event_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trap_view_device_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /trap_view_device_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trap_view_device_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"trap_view_device_events"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /trap_view_devices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trap_view_devices_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"trap_view_devices"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /trap_view_platform/add_user_access(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trap_view_platform_add_user_access_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"trap_view_platform"],[2,[7,"/"],[2,[6,"add_user_access"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /trap_view_platform/device_activate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trap_view_platform_device_activate_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"trap_view_platform"],[2,[7,"/"],[2,[6,"device_activate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /trap_view_platform/device_deactivate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trap_view_platform_device_deactivate_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"trap_view_platform"],[2,[7,"/"],[2,[6,"device_deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /trap_view_platform/device_update_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trap_view_platform_device_update_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"trap_view_platform"],[2,[7,"/"],[2,[6,"device_update_location"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /trap_view_platform/remove_user_access(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trap_view_platform_remove_user_access_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"trap_view_platform"],[2,[7,"/"],[2,[6,"remove_user_access"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /units(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const units_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"units"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json/agri_work_plans/update_agro_operation_locked_to_edit_attribute(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_agro_operation_locked_to_edit_attribute_json_agri_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[6,"update_agro_operation_locked_to_edit_attribute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /new_awp_design/agri_work_plans/:id/update_agro_operations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_agro_operations_new_awp_design_agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_awp_design"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_agro_operations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /json/plant_threat_score_comments/update_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_all_json_plant_threat_score_comments_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"plant_threat_score_comments"],[2,[7,"/"],[2,[6,"update_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company/skyfms_sync_settings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_company_skyfms_sync_settings_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[6,"skyfms_sync_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /agri_work_plans/:id/update_locked_to_edit_attribute(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_locked_to_edit_attribute_agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_locked_to_edit_attribute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/agro_operations/:id/update_locked_to_edit_attribute(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_locked_to_edit_attribute_field_agro_operation_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_locked_to_edit_attribute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/tasks/:id/update_locked_to_edit_attribute(.:format)
 * @param {any} machine_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_locked_to_edit_attribute_machine_machine_task_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_locked_to_edit_attribute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /manual_work_plans/:id/update_locked_to_edit_attribute(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_locked_to_edit_attribute_manual_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manual_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_locked_to_edit_attribute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /new_awp_design/agri_work_plans/:id/update_locked_to_edit_attribute(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_locked_to_edit_attribute_new_awp_design_agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"new_awp_design"],[2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_locked_to_edit_attribute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /json/manual_work_plans/update_manual_work_plan_item_locked_to_edit_attribute(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_manual_work_plan_item_locked_to_edit_attribute_json_manual_work_plans_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"json"],[2,[7,"/"],[2,[6,"manual_work_plans"],[2,[7,"/"],[2,[6,"update_manual_work_plan_item_locked_to_edit_attribute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/agro_operations/update_planned_area(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_planned_area_field_agro_operations_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[6,"update_planned_area"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /plots/:id/plot_rows(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_plot_rows_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"plots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"plot_rows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/manual_work_plan_items/:id/update_status(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_status_field_manual_work_plan_item_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"manual_work_plan_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_test_tasks/new/upload_custom_source(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_custom_source_new_field_soil_test_task_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_test_tasks"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"upload_custom_source"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /upload_data/new/:type(.:format)
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_data_path = /*#__PURE__*/ __route({"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"upload_data"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/leaf_tests/upload_file(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_file_field_leaf_tests_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"leaf_tests"],[2,[7,"/"],[2,[6,"upload_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /shapes_uploads/upload/:type(.:format)
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_shapes_uploads_path = /*#__PURE__*/ __route({"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shapes_uploads"],[2,[7,"/"],[2,[6,"upload"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /upload_data/upload/:type(.:format)
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_upload_data_path = /*#__PURE__*/ __route({"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"upload_data"],[2,[7,"/"],[2,[6,"upload"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /d/users/auth/adfs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_adfs_omniauth_authorize_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"d"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"adfs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_job_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_job_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user_job_events"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /user/legend_scales/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_legend_scale_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"legend_scales"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/legend_scales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_legend_scales_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"legend_scales"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/payment/session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_payment_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"payment"],[2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /d/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"d"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_roles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_role_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_roles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_roles_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user_roles"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /user/units(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_units_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"units"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/actions_statistics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_actions_statistics_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"actions_statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/page_views(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_activity_statistics_pageviews_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"page_views"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /vendor_invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendor_invoice_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendor_invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /vendor_invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendor_invoices_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"vendor_invoices"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /agri_work_plans/:id/versions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const versions_agri_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agri_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"versions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /manual_work_plans/:id/versions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const versions_manual_work_plan_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manual_work_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"versions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /virtual_weather_stations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const virtual_weather_station_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"virtual_weather_stations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/yield_maps/vra_grid(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vra_grid_field_yield_maps_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"yield_maps"],[2,[7,"/"],[2,[6,"vra_grid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/vra/multiple_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vra_multiple_export_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"vra"],[2,[7,"/"],[2,[6,"multiple_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/vra/multiple_send_to_john_deere(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vra_multiple_send_to_john_deere_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"vra"],[2,[7,"/"],[2,[6,"multiple_send_to_john_deere"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/yield_maps/vra_sources(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vra_sources_field_yield_maps_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"yield_maps"],[2,[7,"/"],[2,[6,"vra_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /warehouses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const warehouse_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"warehouses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /warehouse_stocks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const warehouse_stocks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"warehouse_stocks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /warehouses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const warehouses_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"warehouses"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /weather_stations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weather_station_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"weather_stations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /weather_stations/pluviometer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weather_stations_pluviometer_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"weather_stations"],[2,[7,"/"],[2,[6,"pluviometer"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /weedy_fields_monitoring(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weedy_fields_monitoring_index_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"weedy_fields_monitoring"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /wh_cost_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wh_cost_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"wh_cost_reports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /wh_document_status_changes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wh_document_status_change_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"wh_document_status_changes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /wh_inventory_movements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wh_inventory_movements_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"wh_inventory_movements"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /wh_inventory_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wh_inventory_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"wh_inventory_reports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /wh_inventory_transfer_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wh_inventory_transfer_request_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wh_inventory_transfer_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /wh_inventory_transfer_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wh_inventory_transfer_requests_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"wh_inventory_transfer_requests"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /wh_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wh_item_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wh_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /wh_item_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wh_item_group_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wh_item_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /wh_item_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wh_item_groups_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"wh_item_groups"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /wh_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wh_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"wh_items"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /wh_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wh_settings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"wh_settings"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /wh_turnover_movements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wh_turnover_movements_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"wh_turnover_movements"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /wh_turnover_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wh_turnover_reports_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"wh_turnover_reports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /wmo_weather_stations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wmo_weather_station_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wmo_weather_stations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/agro_operations/:id/work_data(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_data_field_agro_operation_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"agro_operations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"work_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /work_recording/start(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_recording_start_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"work_recording"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /work_recording/stop(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_recording_stop_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"work_recording"],[2,[7,"/"],[2,[6,"stop"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /work_recording/timer_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_recording_timer_data_path = /*#__PURE__*/ __route({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"work_recording"],[2,[7,"/"],[2,[6,"timer_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /work_type_measurements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_type_measurement_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"work_type_measurements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /work_type_measurements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_type_measurements_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"work_type_measurements"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /machines/:machine_id/tasks/:id/write_off_act(.:format)
 * @param {any} machine_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const write_off_act_machine_machine_task_path = /*#__PURE__*/ __route({"machine_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"machines"],[2,[7,"/"],[2,[3,"machine_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"write_off_act"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ws_connector/pluviometer/field_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ws_connector_pluviometer_field_groups_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"ws_connector"],[2,[7,"/"],[2,[6,"pluviometer"],[2,[7,"/"],[2,[6,"field_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ws_connector/pluviometer/weather_history_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ws_connector_pluviometer_weather_history_items_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"ws_connector"],[2,[7,"/"],[2,[6,"pluviometer"],[2,[7,"/"],[2,[6,"weather_history_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /actions_statistics_downloads/xlsx(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const xlsx_actions_statistics_downloads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"actions_statistics_downloads"],[2,[7,"/"],[2,[6,"xlsx"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /actions_statistics_downloads/xlsx_consolidated(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const xlsx_consolidated_actions_statistics_downloads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"actions_statistics_downloads"],[2,[7,"/"],[2,[6,"xlsx_consolidated"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /external_service_settings/meteozahist_fields_report/xlsx(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const xlsx_external_service_settings_mfr_index_path = /*#__PURE__*/ __route({"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"external_service_settings"],[2,[7,"/"],[2,[6,"meteozahist_fields_report"],[2,[7,"/"],[2,[6,"xlsx"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /personal_identifiers/xlsx_table(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const xlsx_table_personal_identifiers_path = /*#__PURE__*/ __route({"format":{"d":"xlsx"}}, [2,[7,"/"],[2,[6,"personal_identifiers"],[2,[7,"/"],[2,[6,"xlsx_table"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yield_forecast/crops(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yield_forecast_crops_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"yield_forecast"],[2,[7,"/"],[2,[6,"crops"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yield_forecast/crops/:crop_id/field_groups(.:format)
 * @param {any} crop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yield_forecast_field_groups_path = /*#__PURE__*/ __route({"crop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"yield_forecast"],[2,[7,"/"],[2,[6,"crops"],[2,[7,"/"],[2,[3,"crop_id"],[2,[7,"/"],[2,[6,"field_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /yield_forecast/crops/:crop_id/field_groups/:field_group_id/fields(.:format)
 * @param {any} crop_id
 * @param {any} field_group_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yield_forecast_fields_path = /*#__PURE__*/ __route({"crop_id":{"r":true},"field_group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"yield_forecast"],[2,[7,"/"],[2,[6,"crops"],[2,[7,"/"],[2,[3,"crop_id"],[2,[7,"/"],[2,[6,"field_groups"],[2,[7,"/"],[2,[3,"field_group_id"],[2,[7,"/"],[2,[6,"fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_health_reports/:id/yield_map_attributes(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yield_map_attributes_field_soil_health_report_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_health_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"yield_map_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/soil_health_reports/:id/yield_map_preview(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yield_map_preview_field_soil_health_report_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"soil_health_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"yield_map_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/application_tasks/:id/zone_export/:export_type(.:format)
 * @param {any} field_id
 * @param {any} id
 * @param {any} export_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const zone_export_field_application_task_path = /*#__PURE__*/ __route({"field_id":{"r":true},"id":{"r":true},"export_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"application_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"zone_export"],[2,[7,"/"],[2,[3,"export_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /fields/:field_id/vra_multilayers/zoning(.:format)
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const zoning_field_vra_multilayers_path = /*#__PURE__*/ __route({"field_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"vra_multilayers"],[2,[7,"/"],[2,[6,"zoning"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

